import React, { useState, useEffect, useRef } from "react";

const FLAG_CDN_URL = "https://flagcdn.com/h240";

const countries = [
  // North America
  { code: "ag", name: "Antigua and Barbuda", continent: "North America" },
  { code: "bs", name: "Bahamas", continent: "North America" },
  { code: "bb", name: "Barbados", continent: "North America" },
  { code: "bz", name: "Belize", continent: "North America" },
  { code: "ca", name: "Canada", continent: "North America" },
  { code: "cr", name: "Costa Rica", continent: "North America" },
  { code: "cu", name: "Cuba", continent: "North America" },
  { code: "dm", name: "Dominica", continent: "North America" },
  { code: "do", name: "Dominican Republic", continent: "North America" },
  { code: "sv", name: "El Salvador", continent: "North America" },
  { code: "gd", name: "Grenada", continent: "North America" },
  { code: "gt", name: "Guatemala", continent: "North America" },
  { code: "ht", name: "Haiti", continent: "North America" },
  { code: "hn", name: "Honduras", continent: "North America" },
  { code: "jm", name: "Jamaica", continent: "North America" },
  { code: "mx", name: "Mexico", continent: "North America" },
  { code: "ni", name: "Nicaragua", continent: "North America" },
  { code: "pa", name: "Panama", continent: "North America" },
  { code: "kn", name: "Saint Kitts and Nevis", continent: "North America" },
  { code: "lc", name: "Saint Lucia", continent: "North America" },
  { code: "vc", name: "Saint Vincent and the Grenadines", continent: "North America" },
  { code: "tt", name: "Trinidad and Tobago", continent: "North America" },
  { code: "us", name: "United States of America", continent: "North America" },
  // South America
  { code: "ar", name: "Argentina", continent: "South America" },
  { code: "bo", name: "Bolivia", continent: "South America" },
  { code: "br", name: "Brazil", continent: "South America" },
  { code: "cl", name: "Chile", continent: "South America" },
  { code: "co", name: "Colombia", continent: "South America" },
  { code: "ec", name: "Ecuador", continent: "South America" },
  { code: "gy", name: "Guyana", continent: "South America" },
  { code: "py", name: "Paraguay", continent: "South America" },
  { code: "pe", name: "Peru", continent: "South America" },
  { code: "sr", name: "Suriname", continent: "South America" },
  { code: "uy", name: "Uruguay", continent: "South America" },
  { code: "ve", name: "Venezuela", continent: "South America" },
  // Europe
  { code: "al", name: "Albania", continent: "Europe" },
  { code: "ad", name: "Andorra", continent: "Europe" },
  { code: "at", name: "Austria", continent: "Europe" },
  { code: "by", name: "Belarus", continent: "Europe" },
  { code: "be", name: "Belgium", continent: "Europe" },
  { code: "ba", name: "Bosnia and Herzegovina", continent: "Europe" },
  { code: "bg", name: "Bulgaria", continent: "Europe" },
  { code: "hr", name: "Croatia", continent: "Europe" },
  { code: "cy", name: "Cyprus", continent: "Europe" },
  { code: "cz", name: "Czechia", continent: "Europe" },
  { code: "dk", name: "Denmark", continent: "Europe" },
  { code: "ee", name: "Estonia", continent: "Europe" },
  { code: "fi", name: "Finland", continent: "Europe" },
  { code: "fr", name: "France", continent: "Europe" },
  { code: "de", name: "Germany", continent: "Europe" },
  { code: "gr", name: "Greece", continent: "Europe" },
  { code: "hu", name: "Hungary", continent: "Europe" },
  { code: "is", name: "Iceland", continent: "Europe" },
  { code: "ie", name: "Ireland", continent: "Europe" },
  { code: "it", name: "Italy", continent: "Europe" },
  { code: "xk", name: "Kosovo", continent: "Europe" },
  { code: "lv", name: "Latvia", continent: "Europe" },
  { code: "li", name: "Liechtenstein", continent: "Europe" },
  { code: "lt", name: "Lithuania", continent: "Europe" },
  { code: "lu", name: "Luxembourg", continent: "Europe" },
  { code: "mt", name: "Malta", continent: "Europe" },
  { code: "md", name: "Moldova", continent: "Europe" },
  { code: "mc", name: "Monaco", continent: "Europe" },
  { code: "me", name: "Montenegro", continent: "Europe" },
  { code: "nl", name: "Netherlands", continent: "Europe" },
  { code: "mk", name: "North Macedonia", continent: "Europe" },
  { code: "no", name: "Norway", continent: "Europe" },
  { code: "pl", name: "Poland", continent: "Europe" },
  { code: "pt", name: "Portugal", continent: "Europe" },
  { code: "ro", name: "Romania", continent: "Europe" },
  { code: "ru", name: "Russia", continent: "Europe" },
  { code: "sm", name: "San Marino", continent: "Europe" },
  { code: "rs", name: "Serbia", continent: "Europe" },
  { code: "sk", name: "Slovakia", continent: "Europe" },
  { code: "si", name: "Slovenia", continent: "Europe" },
  { code: "es", name: "Spain", continent: "Europe" },
  { code: "se", name: "Sweden", continent: "Europe" },
  { code: "ch", name: "Switzerland", continent: "Europe" },
  { code: "ua", name: "Ukraine", continent: "Europe" },
  { code: "gb", name: "United Kingdom", continent: "Europe" },
  { code: "va", name: "Vatican City", continent: "Europe" },
  // Africa
  { code: "dz", name: "Algeria", continent: "Africa" },
  { code: "ao", name: "Angola", continent: "Africa" },
  { code: "bj", name: "Benin", continent: "Africa" },
  { code: "bw", name: "Botswana", continent: "Africa" },
  { code: "bf", name: "Burkina Faso", continent: "Africa" },
  { code: "bi", name: "Burundi", continent: "Africa" },
  { code: "cv", name: "Cabo Verde", continent: "Africa" },
  { code: "cm", name: "Cameroon", continent: "Africa" },
  { code: "cf", name: "Central African Republic", continent: "Africa" },
  { code: "td", name: "Chad", continent: "Africa" },
  { code: "km", name: "Comoros", continent: "Africa" },
  { code: "cd", name: "Democratic Republic of the Congo", continent: "Africa" },
  { code: "dj", name: "Djibouti", continent: "Africa" },
  { code: "eg", name: "Egypt", continent: "Africa" },
  { code: "gq", name: "Equatorial Guinea", continent: "Africa" },
  { code: "er", name: "Eritrea", continent: "Africa" },
  { code: "sz", name: "Eswatini", continent: "Africa" },
  { code: "et", name: "Ethiopia", continent: "Africa" },
  { code: "ga", name: "Gabon", continent: "Africa" },
  { code: "gm", name: "Gambia", continent: "Africa" },
  { code: "gh", name: "Ghana", continent: "Africa" },
  { code: "gn", name: "Guinea", continent: "Africa" },
  { code: "gw", name: "Guinea-Bissau", continent: "Africa" },
  { code: "ci", name: "Ivory Coast", continent: "Africa" },
  { code: "ke", name: "Kenya", continent: "Africa" },
  { code: "ls", name: "Lesotho", continent: "Africa" },
  { code: "lr", name: "Liberia", continent: "Africa" },
  { code: "ly", name: "Libya", continent: "Africa" },
  { code: "mg", name: "Madagascar", continent: "Africa" },
  { code: "mw", name: "Malawi", continent: "Africa" },
  { code: "ml", name: "Mali", continent: "Africa" },
  { code: "mr", name: "Mauritania", continent: "Africa" },
  { code: "mu", name: "Mauritius", continent: "Africa" },
  { code: "ma", name: "Morocco", continent: "Africa" },
  { code: "mz", name: "Mozambique", continent: "Africa" },
  { code: "na", name: "Namibia", continent: "Africa" },
  { code: "ne", name: "Niger", continent: "Africa" },
  { code: "ng", name: "Nigeria", continent: "Africa" },
  { code: "cg", name: "Republic of the Congo", continent: "Africa" },
  { code: "rw", name: "Rwanda", continent: "Africa" },
  { code: "st", name: "Sao Tome and Principe", continent: "Africa" },
  { code: "sn", name: "Senegal", continent: "Africa" },
  { code: "sc", name: "Seychelles", continent: "Africa" },
  { code: "sl", name: "Sierra Leone", continent: "Africa" },
  { code: "so", name: "Somalia", continent: "Africa" },
  { code: "za", name: "South Africa", continent: "Africa" },
  { code: "ss", name: "South Sudan", continent: "Africa" },
  { code: "sd", name: "Sudan", continent: "Africa" },
  { code: "tz", name: "Tanzania", continent: "Africa" },
  { code: "tg", name: "Togo", continent: "Africa" },
  { code: "tn", name: "Tunisia", continent: "Africa" },
  { code: "ug", name: "Uganda", continent: "Africa" },
  { code: "zm", name: "Zambia", continent: "Africa" },
  { code: "zw", name: "Zimbabwe", continent: "Africa" },
  // Asia
  { code: "af", name: "Afghanistan", continent: "Asia" },
  { code: "am", name: "Armenia", continent: "Asia" },
  { code: "az", name: "Azerbaijan", continent: "Asia" },
  { code: "bh", name: "Bahrain", continent: "Asia" },
  { code: "bd", name: "Bangladesh", continent: "Asia" },
  { code: "bt", name: "Bhutan", continent: "Asia" },
  { code: "bn", name: "Brunei", continent: "Asia" },
  { code: "kh", name: "Cambodia", continent: "Asia" },
  { code: "cn", name: "China", continent: "Asia" },
  { code: "ge", name: "Georgia", continent: "Asia" },
  { code: "in", name: "India", continent: "Asia" },
  { code: "id", name: "Indonesia", continent: "Asia" },
  { code: "ir", name: "Iran", continent: "Asia" },
  { code: "iq", name: "Iraq", continent: "Asia" },
  { code: "il", name: "Israel", continent: "Asia" },
  { code: "jp", name: "Japan", continent: "Asia" },
  { code: "jo", name: "Jordan", continent: "Asia" },
  { code: "kz", name: "Kazakhstan", continent: "Asia" },
  { code: "kw", name: "Kuwait", continent: "Asia" },
  { code: "kg", name: "Kyrgyzstan", continent: "Asia" },
  { code: "la", name: "Laos", continent: "Asia" },
  { code: "lb", name: "Lebanon", continent: "Asia" },
  { code: "my", name: "Malaysia", continent: "Asia" },
  { code: "mv", name: "Maldives", continent: "Asia" },
  { code: "mn", name: "Mongolia", continent: "Asia" },
  { code: "mm", name: "Myanmar", continent: "Asia" },
  { code: "np", name: "Nepal", continent: "Asia" },
  { code: "kp", name: "North Korea", continent: "Asia" },
  { code: "om", name: "Oman", continent: "Asia" },
  { code: "pk", name: "Pakistan", continent: "Asia" },
  { code: "ps", name: "Palestine", continent: "Asia" },
  { code: "ph", name: "Philippines", continent: "Asia" },
  { code: "qa", name: "Qatar", continent: "Asia" },
  { code: "sa", name: "Saudi Arabia", continent: "Asia" },
  { code: "sg", name: "Singapore", continent: "Asia" },
  { code: "kr", name: "South Korea", continent: "Asia" },
  { code: "lk", name: "Sri Lanka", continent: "Asia" },
  { code: "sy", name: "Syria", continent: "Asia" },
  { code: "tw", name: "Taiwan", continent: "Asia" },
  { code: "tj", name: "Tajikistan", continent: "Asia" },
  { code: "th", name: "Thailand", continent: "Asia" },
  { code: "tl", name: "Timor-Leste", continent: "Asia" },
  { code: "tr", name: "Türkiye", continent: "Asia" },
  { code: "tm", name: "Turkmenistan", continent: "Asia" },
  { code: "ae", name: "United Arab Emirates", continent: "Asia" },
  { code: "uz", name: "Uzbekistan", continent: "Asia" },
  { code: "vn", name: "Vietnam", continent: "Asia" },
  { code: "ye", name: "Yemen", continent: "Asia" },
  // Oceania
  { code: "au", name: "Australia", continent: "Oceania" },
  { code: "fj", name: "Fiji", continent: "Oceania" },
  { code: "ki", name: "Kiribati", continent: "Oceania" },
  { code: "mh", name: "Marshall Islands", continent: "Oceania" },
  { code: "fm", name: "Micronesia", continent: "Oceania" },
  { code: "nr", name: "Nauru", continent: "Oceania" },
  { code: "nz", name: "New Zealand", continent: "Oceania" },
  { code: "pw", name: "Palau", continent: "Oceania" },
  { code: "pg", name: "Papua New Guinea", continent: "Oceania" },
  { code: "ws", name: "Samoa", continent: "Oceania" },
  { code: "sb", name: "Solomon Islands", continent: "Oceania" },
  { code: "to", name: "Tonga", continent: "Oceania" },
  { code: "tv", name: "Tuvalu", continent: "Oceania" },
  { code: "vu", name: "Vanuatu", continent: "Oceania" },
];

// Common abbreviations / alternate short forms that people type instead of
// the full country name. Keyed by country code. Each entry is checked the
// same way as the full name when filtering autocomplete suggestions.
const countryAliases = {
  us: ["usa", "us", "america", "united states", "united states of america"],
  gb: ["uk", "great britain", "britain"],
  de: ["germany", "deutschland"],
  ru: ["russian federation"],
  kr: ["south korea", "korea", "rok"],
  nl: ["netherlands", "holland"],
  za: ["south africa", "rsa"],
  ae: ["uae", "united arab emirates", "emirates"],
  sa: ["saudi arabia", "ksa", "saudi"],
  cz: ["czechia", "czech republic"],
  ir: ["iran", "persia"],
  ci: ["ivory coast", "cote d'ivoire", "cote divoire"],
  la: ["laos", "lao pdr"],
  cg: ["congo", "republic of the congo", "congo-brazzaville"],
  cd: ["drc", "congo", "democratic republic of congo", "congo-kinshasa"],
  kp: ["north korea", "dprk"],
  tl: ["timor-leste", "east timor"],
  do: ["dominican republic", "dr"],
  vc: ["saint vincent", "st vincent"],
  kn: ["saint kitts", "st kitts", "saint kitts and nevis"],
  tr: ["turkey", "turkiye"],
};

// Anonymous, randomly generated identifier stored in the player's own
// localStorage — not tied to any real identity, just lets us later ask
// aggregate questions like "do repeat players improve over time." Falls
// back gracefully if localStorage is unavailable (e.g. private browsing).
const SESSION_ID_KEY = "gtf_session_id";
const getOrCreateSessionId = () => {
  try {
    let id = localStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch (err) {
    return "unknown";
  }
};

const getFlagEmoji = (code) =>
  code
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));

// Font Awesome Free icons (CC BY 4.0 — https://fontawesome.com/license/free).
// Used instead of Unicode glyphs (⏸/▶) since font-based emoji rendering is
// inconsistently honored across platforms (notably Android), even with the
// text-presentation selector. fill="currentColor" so each one inherits
// whatever text color it's placed in, rather than a hardcoded color.
const PauseIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={(size * 512) / 448}
    viewBox="0 0 448 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    />
  </svg>
);

const PlayIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={(size * 512) / 448}
    viewBox="0 0 448 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    />
  </svg>
);

const BoltIcon = ({ size = 14 }) => (
  <svg
    width={(size * 320) / 512}
    height={size}
    viewBox="0 0 320 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    />
  </svg>
);

const FlagIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    />
  </svg>
);

const TrophyIcon = ({ size = 14 }) => (
  <svg
    width={(size * 576) / 512}
    height={size}
    viewBox="0 0 576 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    />
  </svg>
);

const SadCryIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={(size * 512) / 496}
    viewBox="0 0 496 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
    />
  </svg>
);

// Font Awesome Free icons for the dark-mode toggle.
const SunIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    />
  </svg>
);

const MoonIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    />
  </svg>
);

// Font Awesome Free check/times icons — used for both meanings (a "close"
// X and a "wrong answer" X) rather than trying to find visually distinct
// icons for each. The distinction is carried by context (a lone X in a
// corner reads as close; an X next to a checkmark in a results list reads
// as wrong), the same way most icon systems only have one X shape anyway.
const CheckIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    />
  </svg>
);

const TimesIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="-80 0 512 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    />
  </svg>
);

// A small reusable circular gauge — same visual technique as the results
// screen's big percentage ring (background track + a stroke-dasharray
// "progress" circle), but built as its own standalone component rather
// than reusing that ring's code directly, so tweaking this one for new
// use cases (like the Stats screen's difficulty cards) carries no risk
// to that already-working screen.
const GaugeRing = ({ percentage, color, size = 70, strokeWidth = 8 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="var(--border-light)"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - percentage / 100)}
        transform={`rotate(-90 ${center} ${center})`}
      />
      <text
        x={center}
        y={center + size * 0.07}
        textAnchor="middle"
        fontSize={size * 0.24}
        fontWeight="800"
        fill={color}
      >
        {percentage}%
      </text>
    </svg>
  );
};

const CaretUpIcon = ({ size = 10 }) => (
  <svg
    width={(size * 320) / 512}
    height={size}
    viewBox="0 0 320 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    />
  </svg>
);

const CaretDownIcon = ({ size = 10 }) => (
  <svg
    width={(size * 320) / 512}
    height={size}
    viewBox="0 0 320 512"
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
  >
    <path
      fill="currentColor"
      d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    />
  </svg>
);

// The progress donut is a fixed size, but "100/195" needs noticeably more
// horizontal room than "5/10" — rather than resizing the donut itself
// (which would disturb the spacing work done elsewhere), scale the text
// down as the digit count grows so longer numbers still fit comfortably.
const getDonutCounterFontSize = (attempts, total) => {
  const length = `${attempts}/${total}`.length;
  if (length <= 5) return 14;
  if (length === 6) return 12;
  return 10;
};

// Country names range from "Chad" to "Saint Vincent and the Grenadines" —
// rather than let long names wrap and grow the button's height, scale the
// font down so it fits on one line within a fixed-height button instead.
const getOptionButtonFontSize = (name) => {
  const length = name.length;
  if (length <= 28) return "1.1em";
  if (length <= 32) return "0.9em";
  return "0.8em";
};

// Selectable quiz lengths on the start screen. "all" always plays every
// country currently in the list — all 193 UN member states plus the two
// UN observer states (Palestine and Vatican City), 195 total.
// How long the correct/incorrect overlay stays visible before advancing to
// the next question. This delay happens *after* a guess is submitted, so it
// never factors into per-question timing (which measures flag-shown to
// guess-submitted) — safe to tune independently of the timer.
const ANSWER_FEEDBACK_DELAY_MS = 1000;

// If a question sits unanswered this long, the game auto-pauses — the
// same mechanism as manually pressing Pause, just triggered by
// inactivity rather than a click.
const AUTO_PAUSE_DELAY_MS = 20000;

// Formats a millisecond duration as "1m 23s" (or just "45s" under a minute)
// for display on the results screen.
const formatDuration = (ms) => {
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};

// For cumulative totals across every game ever played, which can grow
// into hours or days — formatDuration above only handles minutes/seconds,
// appropriate for a single game's duration.
const formatLongDuration = (ms) => {
  const totalMinutes = Math.round(ms / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

// All continents represented in the country list, used to drive the
// continent-selection checkboxes on the start screen.
const CONTINENTS = ["North America", "South America", "Europe", "Africa", "Asia", "Oceania"];

// Public changelog, shown in-app and mirrored in CHANGELOG.md. Newest
// entries first. Append a new entry here each time you ship something —
// no need for exact dates, just keep the order newest-to-oldest.
const CHANGELOG = [
  {
    version: "1.17",
    title: "A new Stats page",
    items: [
      "Added a Stats page (linked from the footer) showing overall numbers across everyone who's played: games played, average score, questions served, celebrations triggered, total time played, and average time per question.",
      "Added a difficulty breakdown showing pass rate for Easy, Hard, and Pro, each with its own gauge.",
      "Added a sortable, filterable list of every country's pass rate, sort by name or rate, and narrow it down to a single continent.",
    ],
  },
  {
    version: "1.16",
    title: "Achievement badges and a celebrations preview",
    items: [
      "Replaced the single \"Legendary\" badge with four tiers: Bronze, Silver, and Gold for a perfect 197/197 depending on how much of it was played at Hard or Pro, plus a separate Completion badge for playing every country without a perfect score.",
      "Matched the confetti to the new badges, each tier now mixes in its own medal emoji (or, for Gold, medal/trophy/crown together) alongside the flags, with Gold going especially big.",
      "Added a hidden way to replay your results' celebration: three quick clicks on the percentage ring on the results screen.",
    ],
  },
  {
    version: "1.15",
    title: "Completion celebrations and iOS fixes",
    items: [
      "Added two new celebrations: a badge and confetti shower for playing every country in the game, and an even bigger \"Legendary\" one (with trophies and crowns mixed in) for getting every single one correct.",
      "The count slider now supports tapping anywhere on the track to jump straight there, not just dragging the handle.",
      "Fixed the count slider carrying over an inappropriate value when switching to a different continent selection.",
      "The Pause/Resume button now drops to icon-only when space is tight, instead of wrapping onto its own line.",
      "Several iOS-specific fixes: the difficulty selector's border disappearing after switching options, text not scaling consistently in landscape mode, and inconsistent button sizing on the Pause screen.",
      "Replaced the remaining checkmark/X symbols with proper icons, and made the Changelog page's close button and overall background more consistent with the rest of the app.",
    ],
  },
  {
    version: "1.14",
    title: "Dark mode",
    items: [
      "Added dark mode — follows your system preference automatically, with a manual toggle (near the title on every screen) that's remembered for next time.",
      "Fixed the difficulty selector's border sometimes disappearing on iOS after switching between options.",
      "Fixed the footer's Changelog link not resizing along with the rest of the footer text at larger system font sizes or landscape zoom.",
      "Swapped a few placeholder icons for proper Font Awesome ones for consistency.",
    ],
  },
  {
    version: "1.13",
    title: "Auto-pause and icon polish",
    items: [
      "The game now auto-pauses if a question sits unanswered for 20 seconds, using the same Pause screen with a note explaining why.",
      "Properly fixed the score row wrapping badly at higher browser zoom or system font scaling — it now measures itself directly instead of a separate hidden copy, which turned out to be unreliable.",
      "The progress counter (e.g. \"100/195\") now shrinks its text for longer numbers, so 100+ question games display cleanly.",
      "Replaced several emoji (Pause/Resume, Quick Start, empty question filters, footer) with proper icons for consistent rendering across devices.",
      "Widened the continent map on desktop and tablet so it isn't cramped.",
      "Redesigned the footer into a consistent 3-line layout across every screen.",
    ],
  },
  {
    version: "1.12",
    title: "Pause polish and difficulty colors",
    items: [
      "Fixed a bug where using Start again from the Pause screen could leave the next game stuck showing Paused.",
      "The Pause button now stays in place and turns into a Resume button, instead of disappearing while paused.",
      "Gave Easy and Hard their own distinct colors (teal and orange) instead of sharing colors already used elsewhere in the app.",
      "Switched the pause/play symbols to plain Unicode glyphs instead of colorful emoji, for a more consistent look across devices.",
      "More button consistency fixes: matching spacing between stacked buttons, and the Resume button now styled the same as Play again.",
    ],
  },
  {
    version: "1.11",
    title: "Fixed a rapid-click scoring bug, plus layout polish",
    items: [
      "Fixed a bug where answering very quickly (especially spam-clicking multiple choice) could occasionally count one extra attempt that didn't correspond to a real question.",
      "General layout polish: moved to the new guesstheflag.games domain (with giddings.games as the parent site), added a floating close button on the Changelog page, and matched button heights consistently across the app.",
      "Evened out the spacing above and below the flag on the game screen, and combined the difficulty selector and Pause button onto one row.",
      "Small copy changes throughout.",
    ],
  },
  {
    version: "1.10",
    title: "Pause button and two more countries",
    items: [
      "Added a Pause button during play, stops the timer and hides the flag and answers entirely, so you can't use the paused time to think about the current question. Resume picks up exactly where you left off.",
      "Added Taiwan and Kosovo to the country list (197 total), with curated Hard mode similar-country pairings for both.",
      "Reorganized the country list and similar-country data by continent, for easier maintenance going forward (no gameplay change).",
    ],
  },
  {
    version: "1.9",
    title: "Fairness fix, sharing, and polish",
    items: [
      "Fixed a subtle bug in the random shuffle used to pick quiz countries, it wasn't actually uniform, and could noticeably over- or under-represent certain countries depending on their position in the list.",
      "Added a Share results button on the results page (native share sheet on mobile, copy-to-clipboard on desktop), with a special callout for a perfect score.",
      "Added the current version number to the site footer, next to the Changelog link.",
      "Fixed the score row (Correct/Incorrect/progress) sometimes wrapping awkwardly on devices with larger system font scaling or browser zoom, while keeping the original single-line layout for everyone else.",
      "Matched the width of the Start Again and Play Again buttons to the rest of the app's buttons.",
    ],
  },
  {
    version: "1.8",
    title: "Difficulty levels: Easy, Hard, and Pro",
    items: [
      "Replaced the old multiple-choice/type-answer toggle with three levels: Easy (random options), Hard (visually or geographically similar options), and Pro (type the answer yourself).",
      "Curated a similar-country dataset for Hard mode across all 195 countries.",
      "Hard mode automatically disables itself for continent selections that don't have enough similar-country coverage (e.g. South America or Oceania alone), rather than quietly behaving like Easy mode.",
      "Switching levels mid-game only affects the next question, never the one on screen.",
      "Results page shows a per-level breakdown, plus a level indicator on every question in the review list.",
    ],
  },
  {
    version: "1.7",
    title: "Continent map, question slider, and quick start",
    items: [
      "Replaced the continent checkboxes with a clickable world map (real geographic shapes), plus a legend of pill buttons.",
      "Replaced the fixed 10/20/50/100/All buttons with a draggable slider (increments of 10, with the exact total always reachable at the end).",
      "Added a third setup screen to choose how you want to answer, separate from picking continents and question count.",
      "Added a one-tap Quick Start button (20 flags, every continent, Easy) on the home screen.",
    ],
  },
  {
    version: "1.6",
    title: "Results page overhaul",
    items: [
      "Added a live results breakdown: score percentage, correct/incorrect counts, total and average time per question.",
      "Added a per-continent accuracy breakdown when more than one continent was played.",
      "Added a full question-by-question review list, with a filter for correct/incorrect only.",
      "Added a timer, measured per question so the answer-feedback delay never counts against you.",
    ],
  },
  {
    version: "1.5",
    title: "Full country list and smarter multiple choice",
    items: [
      "Expanded from a 10-country demo list to all 193 UN member states, plus Palestine and Vatican City (195 total).",
      "Added continent selection, so you can practice one region at a time.",
      "Split the Americas into North and South America as separate continents.",
      "Multiple-choice options no longer repeat the previous question's answer.",
    ],
  },
  {
    version: "1.4",
    title: "Type-to-answer mode",
    items: [
      "Added a typed-answer mode with autocomplete suggestions as you type.",
      "Added support for common abbreviations (e.g. \"UK\", \"USA\") as valid typed answers.",
      "Added keyboard navigation (arrow keys) through the suggestion list.",
    ],
  },
  {
    version: "1.3",
    title: "Celebrations and polish",
    items: [
      "Added confetti (built from flag emoji) for a perfect score, and a different animation for a zero score.",
      "Added a progress ring and pulsing score counters during play.",
      "Fixed flag images being distorted or cropped on unusual aspect ratios and narrow screens.",
      "Added an emoji fallback for when the flag image CDN is unavailable.",
    ],
  },
  {
    version: "1.2",
    title: "Reliability fixes",
    items: [
      "Fixed a bug where rapid clicking could double-count a question's result.",
      "Fixed flags occasionally showing the previous question's image for a moment before loading.",
      "General mobile layout and spacing fixes.",
    ],
  },
  {
    version: "1.0",
    title: "Original release",
    items: [
      "Basic flag-guessing quiz with multiple choice, built with a small 10-country demo list.",
    ],
  },
];

// Answer-level labels and colors, shared across the mode screen, in-game
// toggle, and results breakdown. Deliberately avoids green/red since those
// already mean correct/incorrect elsewhere in the app.
const LEVEL_LABELS = { 1: "Easy", 2: "Hard", 3: "Pro" };
const LEVEL_COLORS = { 1: "#14b8a6", 2: "#e67e22", 3: "#8e44ad" };

// Results-screen achievement badges. Bronze/Silver/Gold apply only when
// a full-list (every country in the game) run was also a perfect score,
// split by how much of it was played at Hard/Pro versus Easy. "Completion"
// is the more modest tier for playing every country without a perfect
// score.
const BADGE_INFO = {
  gold: { color: "#d4af37", emoji: "🥇", label: "Gold! Every country, all on Pro difficulty" },
  silver: { color: "#a8a9ad", emoji: "🥈", label: "Silver! Every country, all Hard or higher" },
  bronze: { color: "#cd7f32", emoji: "🥉", label: "Bronze! Every country, 100% correct" },
  completion: { color: "#5b6ee1", emoji: "🌍", label: "You played every country in the game" },
};

// Pure function determining which badge key (if any) a given result
// earns — shared by the real results screen and the celebrations preview
// screen, so both always agree on the exact same rules.
const getResultBadgeKey = (resultScore, resultAttempts, resultQuizSetLength, resultAnswerLog) => {
  const isPerfect = resultAttempts > 0 && resultScore === resultAttempts;
  const isFullList = resultQuizSetLength === countries.length;
  if (!isFullList) return null;
  if (!isPerfect) return "completion";
  const hasEasyAnswer = resultAnswerLog.some((a) => a.level === 1);
  const isAllProAnswers =
    resultAnswerLog.length > 0 && resultAnswerLog.every((a) => a.level === 3);
  return isAllProAnswers ? "gold" : hasEasyAnswer ? "bronze" : "silver";
};

// CSS custom properties for light/dark theming. Injected once per screen
// (see THEME_STYLE below) rather than living in a separate stylesheet
// file, since this project keeps everything in one component file. The
// `styles` object below references these by name (var(--x)) instead of
// literal hex values, so switching data-theme on <html> re-themes every
// screen instantly with no component logic involved.
const THEME_STYLE = `
  :root {
    --page-bg: #ffffff;
    --card-bg: #ffffff;
    --text-primary: #333333;
    --text-secondary: #444444;
    --text-tertiary: #666666;
    --text-muted: #888888;
    --text-faint: #999999;
    --border-light: #eeeeee;
    --border-medium: #dddddd;
    --border-strong: #cccccc;
    --chip-bg: #f2f2f2;
    --accent: #007bff;
    --accent-gradient-end: #00c6ff;
    --disabled-bg: #aac6e8;
    --link-tint: #cfe3ff;
    --link-tint-strong: #e3f0ff;
    --link-tint-stronger: #e8f1ff;
    --accent-strong: #004aad;
  }
  [data-theme="dark"] {
    --page-bg: #1e1e1e;
    --card-bg: #1e1e1e;
    --text-primary: #f0f0f0;
    --text-secondary: #d0d0d0;
    --text-tertiary: #b0b0b0;
    --text-muted: #909090;
    --text-faint: #808080;
    --border-light: #333333;
    --border-medium: #3a3a3a;
    --border-strong: #4a4a4a;
    --chip-bg: #2a2a2a;
    --accent: #3b9eff;
    --accent-gradient-end: #00c6ff;
    --disabled-bg: #2c4c73;
    --link-tint: #234066;
    --link-tint-strong: #1c3252;
    --link-tint-stronger: #17293f;
    --accent-strong: #8ec9ff;
  }
  body {
    background-color: var(--page-bg);
    margin: 0;
    transition: background-color 0.2s ease;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }
`;

// Real (simplified) continent coastline shapes for the clickable world-map
// selector on the start screen, derived from an actual world map SVG and
// decimated for file size — not full-resolution borders, but recognizable
// silhouettes. Each is a path "d" string (not a polygon points list) since
// continents like North America include disconnected sub-shapes (islands).
// Coordinates sit within the WORLD_MAP_VIEWBOX below.
const WORLD_MAP_VIEWBOX = "26.6 195.5 357.3 174.8";
const CONTINENT_SHAPES = {
  "North America": "M102.6,286.6 L101.9,288.4 L100.3,286.1 L98.7,288.4 L93.7,285.0 L92.1,280.6 L88.2,279.9 L85.1,276.9 L82.7,277.7 L75.7,274.3 L73.9,272.2 L74.2,268.9 L71.3,264.9 L68.7,257.4 L67.8,257.2 L67.4,259.2 L70.6,267.8 L69.9,268.5 L68.2,266.1 L68.3,264.3 L66.1,262.2 L67.3,261.5 L65.8,255.3 L63.1,253.7 L63.4,249.2 L62.3,248.2 L67.5,236.3 L69.0,236.7 L68.7,237.7 L69.6,236.2 L68.5,233.8 L66.7,233.0 L67.6,229.9 L66.3,229.8 L68.4,227.8 L66.8,228.6 L67.5,227.4 L66.3,227.5 L66.4,223.7 L64.7,224.5 L63.6,222.6 L58.2,221.3 L51.9,223.4 L55.3,221.0 L48.6,224.6 L37.2,228.4 L46.7,223.9 L42.3,224.1 L43.6,222.1 L41.3,221.8 L43.3,221.6 L41.8,221.2 L42.9,220.1 L50.0,217.3 L45.6,217.3 L45.3,216.1 L53.1,215.1 L50.3,213.1 L59.3,210.4 L75.5,212.6 L82.0,211.2 L78.8,212.6 L84.7,210.8 L85.4,212.1 L87.0,211.3 L86.2,212.0 L93.1,212.5 L94.0,213.1 L92.3,213.6 L96.9,213.5 L97.8,214.9 L100.9,212.9 L98.3,213.2 L100.9,212.5 L103.7,213.9 L107.9,213.0 L108.7,214.3 L111.2,212.6 L110.4,210.5 L113.0,209.3 L114.0,211.2 L112.7,211.7 L114.3,211.9 L113.7,213.2 L115.9,212.6 L115.4,214.4 L118.7,211.5 L121.2,211.8 L120.2,214.5 L115.4,215.1 L114.1,216.4 L112.4,215.8 L113.7,217.0 L109.0,218.3 L109.3,219.1 L105.6,220.8 L103.0,223.7 L104.2,223.9 L103.7,225.9 L111.7,228.1 L111.0,231.6 L113.2,232.6 L114.2,228.7 L118.3,226.1 L117.5,224.0 L120.1,219.8 L123.9,219.6 L126.9,221.3 L125.7,223.8 L127.2,224.5 L130.9,222.2 L132.3,228.1 L134.8,228.8 L131.7,230.3 L134.6,229.3 L135.4,231.8 L130.5,234.0 L124.4,234.1 L115.1,239.9 L124.9,235.3 L126.0,235.7 L123.7,236.8 L125.1,237.2 L124.7,239.0 L127.7,240.2 L122.5,242.3 L123.0,240.8 L125.1,240.1 L124.1,239.8 L119.6,241.2 L116.8,243.9 L117.6,244.7 L112.9,246.0 L109.9,250.3 L110.3,247.7 L108.8,251.9 L109.6,252.3 L102.2,258.4 L101.9,265.4 L101.1,265.7 L99.3,259.4 L93.0,259.0 L93.5,260.7 L89.1,259.8 L85.0,261.8 L82.7,268.9 L83.6,273.0 L85.2,274.5 L88.5,274.2 L90.3,270.9 L94.0,270.2 L90.9,277.4 L96.8,278.2 L95.7,283.2 L97.3,286.1 L101.8,285.8 L102.6,286.6Z M168.4,210.4 L166.3,210.9 L168.2,210.3 L168.4,210.4Z M145.5,211.2 L146.1,211.9 L144.7,212.2 L144.6,211.0 L145.5,211.2Z M108.7,211.7 L109.7,212.7 L106.5,212.4 L108.6,211.5 L108.7,211.7Z M123.4,212.6 L124.4,212.1 L123.4,212.6Z M125.7,213.2 L125.1,214.3 L124.1,214.3 L124.9,213.3 L125.7,213.2Z M116.0,216.3 L119.0,218.2 L113.0,218.3 L115.9,215.8 L116.0,216.3Z M40.1,218.3 L41.4,218.8 L40.1,218.3Z M117.0,219.1 L115.8,219.2 L117.0,219.1Z M118.8,219.7 L118.4,219.8 L118.8,219.7Z M40.4,222.0 L39.0,222.2 L40.4,222.0Z M56.2,222.7 L57.3,222.2 L56.2,222.7Z M50.4,224.4 L49.3,224.7 L50.3,224.3 L50.4,224.4Z M66.3,224.5 L65.4,225.8 L66.3,224.5Z M65.4,224.5 L64.4,224.8 L65.4,224.5Z M49.4,225.0 L48.4,225.3 L49.4,225.0Z M65.3,225.5 L64.4,226.8 L65.1,225.3 L65.3,225.5Z M65.7,226.1 L64.8,227.0 L65.3,226.1 L65.7,226.1Z M115.8,226.8 L114.7,227.4 L115.6,226.4 L115.8,226.8Z M65.6,226.7 L65.7,228.6 L65.2,227.2 L65.6,226.7Z M67.3,227.6 L66.2,228.1 L67.4,227.2 L67.3,227.6Z M36.7,228.3 L35.0,229.0 L36.4,228.3 L36.7,228.3Z M64.3,229.3 L65.3,229.5 L64.3,230.4 L63.8,229.8 L64.3,229.3Z M32.6,229.6 L32.1,229.7 L32.6,229.6Z M30.7,230.3 L29.6,230.8 L30.6,230.1 L30.7,230.3Z M64.5,230.4 L64.0,231.6 L63.9,230.6 L64.5,230.4Z M99.6,268.1 L106.1,270.9 L107.5,271.8 L106.4,272.3 L103.6,272.4 L104.3,271.4 L99.7,268.8 L96.8,269.9 L98.3,268.4 L99.6,268.1Z M109.7,274.7 L106.9,274.3 L109.2,273.9 L108.5,272.3 L113.5,274.0 L110.0,275.2 L109.7,274.7Z M115.8,274.1 L114.7,274.1 L115.8,274.1Z M103.8,274.1 L104.9,274.8 L103.8,275.1 L103.2,274.1 L103.8,274.1Z M120.5,284.7 L119.6,284.8 L120.5,284.0 L120.5,284.7Z M112.2,231.0 L111.1,230.7 L112.0,230.5 L112.2,231.0Z M135.5,232.5 L133.5,234.8 L136.4,235.2 L135.6,237.1 L136.7,237.4 L135.5,238.4 L135.3,237.0 L133.4,238.2 L134.6,237.3 L130.3,237.0 L134.9,232.4 L135.5,232.5Z M66.4,233.4 L68.1,234.0 L68.5,236.4 L65.9,233.3 L66.4,233.4Z M128.5,235.5 L126.2,234.6 L128.5,235.2 L128.5,235.5Z M125.5,238.7 L127.2,238.8 L125.3,238.3 L125.5,238.7Z M128.1,239.2 L129.2,239.1 L127.6,239.8 L128.8,238.1 L128.5,239.1 L128.1,239.2Z M114.9,245.5 L113.7,245.6 L114.9,245.5Z M104.5,266.1 L104.3,265.7 L104.5,266.1Z M168.7,198.5 L174.8,199.3 L168.9,199.6 L174.8,199.7 L173.1,200.6 L181.7,200.2 L174.9,201.6 L175.6,202.2 L173.2,203.5 L175.4,204.5 L172.8,204.7 L174.4,205.5 L173.2,206.4 L174.3,206.7 L171.8,206.9 L173.1,207.7 L168.0,208.1 L171.7,208.3 L169.5,208.8 L171.6,210.8 L166.6,210.3 L166.5,211.2 L170.8,211.2 L162.2,213.1 L159.0,215.4 L153.5,216.7 L153.5,218.2 L149.2,222.7 L145.2,221.0 L144.0,218.3 L145.2,217.0 L143.8,217.6 L143.4,216.1 L143.7,214.2 L146.2,213.7 L143.8,214.0 L146.3,213.2 L144.4,213.2 L147.6,211.4 L144.9,210.9 L147.4,211.0 L146.6,209.6 L144.2,209.7 L145.6,208.4 L145.2,206.7 L142.1,205.0 L136.8,205.2 L135.5,204.1 L139.0,203.6 L134.7,203.1 L145.9,199.9 L158.0,199.9 L157.3,199.0 L163.7,198.6 L168.7,198.5Z M141.0,198.9 L146.3,199.4 L133.1,202.1 L133.9,202.6 L127.2,205.0 L121.0,204.4 L125.9,203.7 L123.6,203.1 L128.1,202.4 L126.4,201.2 L133.9,200.7 L123.9,200.0 L133.6,199.0 L141.0,198.9Z M158.0,199.5 L157.1,199.2 L158.0,199.5Z M123.1,200.4 L126.3,201.9 L122.7,203.1 L118.6,202.0 L120.6,200.6 L123.1,200.4Z M112.6,202.0 L114.5,203.4 L111.0,203.0 L111.3,202.1 L112.6,202.0Z M117.4,202.8 L116.1,203.5 L116.2,202.5 L117.4,202.8Z M107.2,202.7 L104.5,202.9 L107.0,202.6 L107.2,202.7Z M106.2,203.2 L103.9,203.4 L106.2,203.2Z M117.3,203.5 L116.6,203.8 L117.3,203.5Z M101.3,203.8 L96.6,205.4 L94.8,205.0 L98.8,203.9 L101.3,203.8Z M117.2,204.3 L120.1,205.6 L127.1,205.6 L126.4,206.6 L119.9,206.7 L117.4,206.4 L117.8,204.9 L115.5,204.3 L117.2,204.3Z M105.7,205.2 L107.7,205.5 L106.8,206.0 L100.9,206.8 L102.8,206.0 L97.8,205.9 L100.5,204.8 L104.6,205.7 L106.3,204.5 L105.7,205.2Z M114.4,204.7 L111.1,206.2 L111.9,205.5 L109.7,205.7 L111.1,204.8 L113.8,204.5 L114.4,204.7Z M110.3,205.1 L109.4,205.4 L110.0,204.9 L110.3,205.1Z M97.6,205.6 L98.5,205.2 L97.6,205.6Z M116.3,206.2 L114.0,206.1 L116.1,205.6 L116.3,206.2Z M94.9,207.1 L97.6,207.8 L89.2,210.2 L88.0,209.1 L91.2,206.9 L94.1,206.7 L94.9,207.1Z M115.7,207.0 L117.9,207.3 L113.5,209.2 L112.9,208.5 L114.4,207.2 L115.7,207.0Z M111.7,207.3 L112.0,207.1 L111.7,207.3Z M110.3,207.3 L112.4,207.6 L109.6,209.9 L107.1,208.5 L109.5,207.4 L110.3,207.3Z M118.8,210.3 L123.9,207.5 L125.0,208.5 L124.1,209.1 L128.9,208.8 L131.4,209.9 L130.9,210.8 L133.3,210.8 L132.4,211.4 L133.5,211.1 L132.6,211.8 L133.7,212.3 L132.4,212.9 L137.0,215.0 L134.1,216.9 L132.3,215.1 L130.9,215.6 L132.7,217.9 L131.5,219.4 L128.9,218.3 L130.2,220.3 L126.5,219.0 L125.6,217.3 L121.6,217.5 L128.1,214.3 L124.6,210.8 L116.5,210.8 L118.3,210.3 L116.4,209.8 L118.1,208.2 L122.0,207.4 L120.1,208.4 L120.2,209.9 L118.8,210.3Z M126.0,207.5 L128.5,208.2 L125.7,208.5 L125.3,207.5 L126.0,207.5Z M105.3,208.3 L104.8,207.5 L106.1,207.9 L105.3,208.3Z M97.5,208.6 L101.5,208.3 L101.8,209.5 L103.0,208.1 L104.8,208.2 L104.1,210.2 L105.9,211.7 L94.8,213.0 L93.0,211.3 L97.5,211.1 L93.1,210.7 L95.2,209.8 L93.1,209.6 L98.4,208.0 L97.5,208.6Z",
  "South America": "M101.9,288.4 L104.8,284.1 L109.0,281.8 L108.8,286.0 L110.9,282.1 L113.0,284.3 L119.2,284.0 L119.0,285.1 L120.6,285.7 L119.7,286.6 L122.3,287.3 L124.4,290.3 L128.0,290.2 L130.8,292.3 L132.2,296.0 L129.3,299.4 L131.1,298.7 L132.6,300.7 L135.0,298.3 L138.0,299.7 L137.9,301.5 L139.4,300.5 L143.1,301.1 L148.3,304.5 L148.5,308.8 L144.5,314.4 L144.7,319.9 L143.2,325.2 L135.7,329.5 L135.9,333.7 L131.5,341.4 L127.7,341.2 L126.8,339.5 L129.4,343.7 L129.0,345.8 L124.3,346.7 L124.4,349.6 L122.2,349.3 L124.3,351.7 L122.9,351.7 L123.1,354.5 L121.6,355.7 L124.1,358.1 L122.1,361.1 L123.5,363.4 L120.6,365.0 L121.2,364.1 L119.6,364.6 L120.4,363.7 L118.4,363.9 L117.9,363.2 L119.4,362.9 L116.4,361.5 L117.0,360.1 L115.6,358.2 L116.8,358.4 L114.0,356.5 L116.0,354.1 L115.2,350.7 L113.4,349.6 L112.4,344.6 L113.2,340.2 L111.3,320.8 L104.7,316.0 L98.3,305.1 L98.0,303.0 L99.7,300.8 L98.3,300.3 L98.4,298.9 L102.4,293.0 L102.4,289.3 L101.9,288.4Z M87.0,297.4 L87.0,298.8 L86.8,297.4 L87.0,297.4Z M131.8,297.6 L133.9,297.9 L133.3,299.4 L131.6,299.8 L131.4,297.8 L131.8,297.6Z M130.3,299.2 L130.7,298.8 L130.3,299.2Z M114.5,352.4 L113.6,350.5 L114.6,351.9 L114.5,352.4Z M114.9,353.7 L114.6,353.4 L114.9,353.7Z M116.1,359.2 L116.4,360.7 L115.8,359.1 L116.1,359.2Z M132.1,362.2 L133.2,362.7 L132.1,362.7 L132.1,362.2Z M130.7,362.4 L131.8,362.4 L131.0,362.8 L130.7,362.4Z M122.7,363.7 L127.6,366.5 L121.3,366.1 L122.1,365.0 L123.9,366.0 L122.0,364.3 L122.7,363.7Z M119.8,364.8 L120.2,365.6 L119.1,364.8 L119.8,364.8Z M123.4,366.5 L125.2,367.3 L123.4,366.9 L123.4,366.5Z M126.1,366.8 L125.9,366.7 L126.1,366.8Z",
  "Europe": "M236.3,200.8 L237.7,200.6 L236.3,200.8Z M229.8,200.5 L232.1,200.8 L229.4,200.7 L229.8,200.5Z M226.6,200.6 L226.0,201.0 L226.6,200.6Z M235.3,200.7 L233.5,200.7 L235.3,200.7Z M224.6,200.7 L223.0,200.9 L224.6,200.7Z M205.3,201.2 L209.7,201.3 L207.7,202.2 L203.1,201.3 L205.3,201.2Z M202.3,201.5 L205.8,202.6 L202.4,204.7 L200.4,203.7 L202.5,203.4 L200.1,203.3 L202.4,203.0 L199.6,203.1 L197.9,201.6 L201.6,201.7 L202.3,201.5Z M206.0,202.7 L208.6,203.5 L207.1,204.0 L205.0,202.8 L206.0,202.7Z M241.9,205.0 L234.3,207.9 L232.0,207.5 L234.0,205.8 L242.6,204.7 L241.9,205.0Z M233.4,207.9 L236.2,210.6 L235.3,210.8 L231.2,209.8 L232.2,207.9 L233.4,207.9Z M245.6,213.0 L246.1,214.9 L241.6,217.6 L242.4,223.1 L241.2,226.1 L242.2,227.0 L240.0,227.9 L241.9,229.5 L243.7,229.1 L243.6,231.2 L246.4,233.3 L240.0,233.6 L236.1,232.2 L232.8,235.1 L235.8,238.9 L233.7,241.0 L237.4,246.5 L236.7,246.2 L236.0,245.9 L235.3,245.7 L234.7,245.4 L234.1,245.1 L233.4,244.8 L232.8,244.5 L232.2,244.2 L231.5,243.9 L230.9,243.6 L230.2,243.3 L229.6,243.0 L228.9,242.8 L228.2,242.5 L223.7,240.4 L225.9,237.7 L221.8,239.1 L223.6,240.0 L221.1,241.3 L219.6,240.0 L220.7,239.4 L217.8,238.6 L214.9,243.7 L216.4,245.6 L214.0,246.6 L212.7,245.5 L210.2,246.2 L211.8,249.7 L210.8,249.5 L210.8,251.2 L208.9,249.4 L210.9,249.2 L208.8,248.8 L207.0,246.4 L207.1,244.6 L201.1,239.6 L199.7,240.0 L199.9,241.5 L206.1,246.7 L204.5,246.2 L203.7,249.4 L203.3,246.8 L196.3,241.3 L193.7,242.9 L190.8,242.8 L190.8,244.4 L188.5,245.5 L185.2,250.9 L181.6,251.8 L180.3,250.3 L178.2,250.6 L178.8,242.6 L186.1,242.3 L186.6,238.9 L183.3,236.1 L186.5,236.0 L186.1,234.7 L187.7,235.2 L192.5,230.8 L196.1,230.0 L196.2,225.8 L197.9,225.4 L197.6,229.0 L201.7,229.9 L207.8,228.4 L208.1,225.3 L210.5,225.8 L209.6,223.4 L215.4,222.6 L207.6,221.8 L207.1,219.5 L210.6,216.8 L207.9,215.9 L204.3,219.2 L203.9,221.7 L205.4,222.7 L203.3,222.9 L205.1,223.1 L201.3,227.8 L200.1,227.8 L198.0,222.9 L195.8,224.6 L193.5,224.2 L193.1,220.0 L198.1,218.5 L197.1,218.1 L204.2,211.9 L211.6,210.2 L223.3,213.8 L223.7,214.8 L221.5,215.6 L216.2,214.4 L221.2,218.1 L220.4,216.6 L223.0,217.3 L222.9,216.1 L224.7,215.1 L226.4,215.7 L225.2,212.9 L227.3,213.0 L228.1,213.7 L226.8,214.2 L228.4,214.8 L233.7,212.4 L233.5,213.2 L239.0,213.1 L239.3,211.5 L244.7,212.6 L245.6,213.0Z M238.8,211.4 L237.4,210.9 L238.8,211.4Z M204.9,211.3 L204.0,211.8 L204.9,211.3Z M230.7,212.2 L229.5,212.7 L229.7,211.9 L230.7,212.2Z M202.1,212.9 L200.9,213.2 L202.2,212.1 L202.1,212.9Z M175.7,215.4 L177.2,216.3 L176.2,217.4 L169.1,218.1 L169.8,217.3 L168.1,217.0 L170.0,216.3 L168.1,216.3 L169.0,215.5 L170.6,216.3 L175.3,215.1 L175.7,215.4Z M185.6,224.2 L184.8,225.2 L186.7,225.4 L185.3,227.0 L188.1,229.4 L188.1,230.8 L189.6,231.0 L189.3,232.7 L182.9,234.3 L185.5,232.4 L183.2,232.3 L185.5,229.4 L183.4,228.5 L183.8,227.1 L182.9,227.9 L183.0,225.4 L185.6,224.0 L185.6,224.2Z M208.8,224.1 L208.2,224.5 L208.8,224.1Z M182.8,224.4 L181.9,224.6 L182.7,224.2 L182.8,224.4Z M205.7,225.0 L205.0,225.9 L205.2,225.0 L205.7,225.0Z M199.8,227.4 L199.2,228.6 L198.3,227.5 L199.8,227.1 L199.8,227.4Z M181.5,228.3 L183.1,228.9 L181.8,231.7 L178.2,232.1 L179.6,230.5 L178.8,229.2 L181.5,227.9 L181.5,228.3Z M197.0,243.3 L196.7,245.1 L196.2,243.6 L197.0,243.3Z M197.2,245.7 L197.1,247.9 L195.9,247.8 L195.7,246.0 L196.8,245.3 L197.2,245.7Z M190.6,247.1 L190.6,246.8 L190.6,247.1Z M211.1,248.1 L212.0,249.1 L210.9,248.3 L211.1,248.1Z M203.2,249.1 L202.8,251.0 L200.0,249.6 L202.5,249.1 L203.2,249.1Z M211.8,252.5 L211.5,252.5 L211.8,252.5Z M231.8,200.1 L230.5,200.4 L231.8,200.1Z",
  "Africa": "M222.7,257.8 L223.2,262.0 L221.2,259.5 L221.3,260.8 L229.7,278.3 L233.4,281.3 L233.0,282.9 L235.6,284.3 L241.8,282.4 L242.3,284.0 L239.0,291.8 L229.5,303.4 L230.6,317.1 L224.1,322.6 L224.6,328.1 L221.7,330.0 L221.0,333.8 L215.2,340.0 L207.9,341.6 L206.2,340.8 L202.4,326.2 L199.5,320.3 L201.8,311.5 L200.1,305.2 L200.9,304.9 L196.3,298.4 L197.3,297.4 L197.0,292.5 L195.9,291.5 L193.3,292.1 L191.2,289.4 L184.5,291.5 L176.8,291.1 L168.7,281.9 L169.3,280.7 L168.0,278.8 L169.6,274.1 L168.6,271.1 L171.8,264.3 L176.1,260.7 L177.6,256.2 L181.8,252.0 L185.2,253.0 L188.6,251.2 L197.2,250.2 L198.7,250.8 L197.7,254.6 L206.9,259.1 L209.6,255.8 L217.4,258.4 L222.5,258.0 L222.7,257.8Z M240.5,313.2 L241.3,316.9 L237.0,328.9 L235.2,329.9 L233.6,329.1 L234.2,319.5 L234.8,318.0 L238.1,316.5 L240.1,312.8 L240.5,313.2Z",
  "Asia": "M305.7,272.2 L305.5,273.8 L303.6,274.1 L303.9,272.4 L305.4,272.0 L305.7,272.2Z M316.9,274.0 L318.8,275.8 L318.5,279.7 L320.8,280.1 L321.2,281.6 L319.4,279.9 L319.6,280.8 L317.3,280.1 L316.0,276.9 L316.4,274.1 L316.9,274.0Z M287.4,282.9 L287.3,282.3 L287.4,282.9Z M317.4,280.5 L318.2,282.1 L317.1,280.4 L317.4,280.5Z M245.0,281.5 L244.6,281.7 L245.0,281.5Z M320.9,282.0 L320.3,281.6 L320.9,282.0Z M322.5,281.7 L322.7,283.4 L321.5,281.6 L322.5,281.7Z M319.6,282.8 L319.2,284.3 L319.0,282.5 L319.6,282.8Z M321.9,283.2 L322.3,284.7 L321.6,282.9 L321.9,283.2Z M314.4,286.8 L316.4,283.2 L315.1,286.3 L314.4,286.8Z M320.9,285.6 L321.1,284.8 L320.9,285.6Z M320.6,286.0 L320.3,283.7 L320.8,285.7 L320.6,286.0Z M273.7,285.1 L275.9,288.3 L274.0,289.7 L273.9,285.7 L273.7,285.1Z M323.7,285.7 L324.6,288.3 L323.3,290.4 L321.7,287.8 L319.6,288.7 L323.2,285.2 L323.7,285.7Z M314.0,289.0 L316.7,290.7 L314.5,292.9 L316.6,296.3 L315.2,296.6 L313.2,302.0 L311.8,302.8 L310.1,301.2 L307.0,301.2 L305.6,297.1 L306.1,295.1 L307.8,295.6 L313.9,288.7 L314.0,289.0Z M291.9,290.9 L299.7,296.9 L301.0,300.7 L302.4,301.4 L302.1,304.7 L300.7,305.0 L290.8,291.5 L290.7,290.4 L291.5,290.8 L291.9,290.9Z M326.1,296.4 L327.2,295.5 L326.7,298.4 L326.0,296.2 L326.1,296.4Z M323.0,296.2 L318.1,296.9 L318.4,299.2 L321.4,298.8 L319.2,300.0 L320.8,303.0 L319.2,303.3 L318.4,300.9 L317.2,304.7 L316.3,301.0 L318.0,296.3 L323.4,295.6 L323.0,296.2Z M293.1,295.6 L293.3,296.7 L292.7,295.7 L293.1,295.6Z M329.5,297.5 L328.9,297.8 L329.5,297.5Z M340.6,300.8 L340.0,309.0 L337.8,307.8 L337.2,304.4 L332.5,301.7 L331.8,302.7 L330.7,301.0 L332.9,300.2 L329.7,299.3 L330.9,298.1 L333.0,298.4 L334.0,301.7 L337.1,299.4 L340.2,300.6 L340.6,300.8Z M334.5,298.3 L335.0,298.9 L334.5,298.3Z M294.9,299.7 L294.3,299.0 L295.1,299.6 L294.9,299.7Z M302.5,299.6 L303.1,301.4 L301.4,300.1 L302.3,299.4 L302.5,299.6Z M334.6,299.5 L336.1,299.8 L334.6,299.6 L334.6,299.5Z M328.3,301.1 L329.4,302.4 L327.1,301.8 L326.6,301.1 L327.9,301.0 L328.3,301.1Z M325.1,301.4 L324.9,302.3 L324.2,301.5 L325.1,301.4Z M321.1,303.2 L320.3,304.5 L320.9,303.1 L321.1,303.2Z M298.1,205.4 L302.5,205.6 L297.7,206.4 L296.4,206.0 L296.8,205.0 L298.1,205.4Z M303.9,205.8 L307.4,206.3 L303.6,206.0 L303.9,205.8Z M278.7,206.8 L277.6,206.7 L278.7,206.8Z M301.9,207.3 L301.1,207.4 L301.9,207.3Z M245.7,208.1 L246.4,208.1 L245.7,208.1Z M335.0,210.5 L337.4,210.2 L335.0,210.5Z M328.7,211.8 L327.2,211.5 L328.5,211.5 L328.7,211.8Z M342.8,228.5 L341.6,227.9 L342.8,228.5Z M321.0,229.0 L327.0,235.7 L325.4,235.3 L327.9,238.8 L326.7,238.4 L326.8,239.4 L320.7,229.2 L321.0,229.0Z M333.6,240.1 L332.8,240.9 L332.9,240.1 L333.6,240.1Z M329.7,241.6 L331.1,241.4 L331.8,242.8 L330.5,244.3 L327.4,243.6 L328.5,244.5 L327.8,245.0 L326.8,240.3 L328.1,240.8 L329.7,241.6Z M328.9,245.1 L330.9,247.9 L331.1,253.3 L330.6,252.3 L330.1,253.6 L327.9,253.1 L327.6,255.0 L325.8,253.4 L322.3,254.4 L323.6,252.5 L326.4,252.5 L326.7,250.1 L328.3,250.3 L328.5,244.9 L328.9,245.1Z M325.7,254.1 L326.0,255.4 L324.4,255.8 L324.2,254.4 L325.3,253.9 L325.7,254.1Z M322.7,254.9 L323.9,255.9 L323.8,257.7 L322.7,257.8 L321.2,255.2 L322.3,254.6 L322.7,254.9Z M315.9,268.9 L314.7,268.2 L315.2,265.8 L316.2,265.9 L316.1,268.4 L315.9,268.9Z M260.2,200.5 L261.4,201.2 L257.2,201.1 L259.5,200.3 L260.2,200.5Z M261.9,201.3 L264.3,202.5 L259.9,201.4 L261.9,201.3Z M258.6,201.7 L259.2,201.5 L258.6,201.7Z M266.5,202.1 L269.0,202.8 L264.8,203.3 L265.4,202.0 L266.5,202.1Z M350.4,216.2 L350.1,217.6 L342.3,215.6 L343.1,217.0 L340.4,217.0 L345.9,219.8 L341.7,220.5 L340.8,222.5 L334.8,222.4 L335.2,224.7 L338.3,226.9 L337.3,227.0 L338.6,228.6 L337.3,229.3 L338.1,230.4 L337.0,233.2 L331.1,226.3 L330.9,225.1 L333.9,221.4 L332.7,219.4 L331.0,221.7 L329.9,220.4 L327.4,220.4 L326.6,222.7 L328.0,223.4 L316.3,223.6 L313.6,228.4 L320.7,230.5 L323.1,236.2 L321.5,242.4 L320.0,243.4 L318.3,242.7 L316.0,247.1 L320.0,252.9 L317.6,254.0 L316.0,249.6 L314.0,249.2 L313.9,247.4 L312.6,246.9 L310.1,248.4 L309.7,245.7 L306.5,247.9 L309.1,250.4 L312.2,250.1 L309.9,253.5 L313.7,257.1 L312.7,257.2 L314.1,258.3 L312.9,259.0 L314.6,259.6 L314.8,261.6 L313.6,265.3 L310.7,268.4 L308.8,269.3 L307.6,268.5 L308.0,269.4 L304.7,270.9 L305.1,271.7 L302.7,269.8 L301.0,271.0 L300.2,273.5 L304.3,278.1 L305.0,283.2 L300.9,286.7 L300.9,284.8 L295.1,280.6 L294.5,285.2 L299.5,291.4 L300.4,295.8 L297.2,293.9 L293.6,286.9 L293.8,282.1 L292.0,276.6 L291.2,275.6 L289.7,277.6 L288.5,277.3 L287.7,272.9 L283.3,268.1 L283.1,269.9 L279.9,270.3 L279.8,271.8 L273.5,277.6 L273.5,284.5 L271.1,287.3 L266.1,277.2 L264.3,269.3 L262.5,271.3 L260.5,269.4 L261.7,268.4 L258.9,267.4 L257.3,265.1 L247.6,264.8 L246.9,263.2 L244.7,263.9 L241.4,262.2 L239.4,259.2 L237.3,259.5 L240.8,266.1 L241.5,264.7 L241.4,266.7 L244.2,267.0 L246.6,264.2 L247.1,266.5 L250.7,269.4 L248.9,273.4 L246.1,276.0 L234.4,281.6 L232.4,275.5 L223.4,261.8 L222.7,257.8 L224.7,250.8 L221.2,252.0 L215.2,250.5 L214.3,246.7 L216.9,245.4 L222.9,244.4 L225.7,245.3 L228.6,245.1 L227.9,242.4 L233.9,244.7 L237.2,246.5 L238.1,246.0 L239.5,250.9 L242.4,250.7 L240.5,246.3 L242.2,245.3 L241.3,244.2 L240.4,245.1 L237.2,241.1 L239.8,240.1 L239.6,238.5 L235.2,238.6 L232.8,235.1 L236.1,232.2 L240.0,233.6 L246.4,233.3 L243.6,231.2 L243.7,229.1 L241.9,229.5 L240.0,227.9 L242.2,227.0 L241.2,226.1 L242.4,223.1 L241.6,217.6 L246.4,214.3 L245.6,213.0 L246.4,212.5 L243.5,210.4 L245.0,208.3 L247.6,208.6 L250.3,213.7 L249.0,215.1 L247.3,214.8 L250.0,215.4 L251.7,213.8 L251.0,212.7 L255.3,214.0 L250.4,212.3 L248.5,209.8 L249.1,208.4 L250.3,210.0 L253.2,210.4 L250.6,209.4 L252.3,208.9 L256.3,209.5 L257.0,211.1 L256.9,209.7 L253.4,207.7 L258.8,207.4 L257.2,206.9 L258.0,206.1 L266.7,205.1 L265.7,204.7 L268.6,203.5 L277.8,205.4 L273.7,208.3 L276.6,207.2 L290.3,207.7 L296.2,210.6 L296.3,209.4 L301.3,210.0 L302.7,209.8 L301.3,209.1 L301.9,208.3 L304.3,208.5 L317.8,210.3 L323.2,212.5 L323.0,211.7 L330.0,212.7 L330.8,212.4 L329.1,211.3 L334.0,211.5 L350.4,216.2Z M333.6,304.7 L333.5,304.4 L333.6,304.7Z M303.7,305.1 L309.3,306.2 L311.4,308.6 L302.6,306.8 L301.6,306.1 L303.4,305.0 L303.7,305.1Z M310.7,306.5 L309.5,306.4 L310.9,306.2 L310.7,306.5Z M329.7,307.6 L330.1,306.9 L329.7,307.6Z M337.5,308.0 L336.5,308.1 L337.0,307.2 L338.0,307.2 L337.5,308.0Z M312.4,307.8 L312.1,308.6 L311.3,307.8 L312.4,307.8Z M315.4,308.0 L316.3,308.4 L313.8,308.9 L315.3,307.8 L315.4,308.0Z M320.3,308.4 L317.2,308.2 L320.6,307.8 L320.3,308.4Z M313.6,308.4 L313.8,308.1 L313.6,308.4Z M325.2,308.1 L321.1,310.5 L324.9,308.0 L325.2,308.1Z M317.2,309.3 L317.6,310.5 L316.3,309.4 L317.2,309.3Z",
  "Oceania": "M380.9,317.9 L380.4,318.0 L380.9,317.9Z M378.7,319.5 L378.0,320.6 L378.0,319.6 L378.7,319.5Z M362.6,323.0 L365.0,325.5 L362.6,323.4 L362.6,323.0Z M365.4,341.7 L366.5,345.2 L368.9,345.3 L362.4,349.8 L365.6,344.3 L365.3,341.3 L365.4,341.7Z M328.3,342.8 L327.3,343.2 L328.1,342.6 L328.3,342.8Z M360.9,349.7 L362.2,349.5 L361.7,350.4 L358.6,353.1 L353.2,356.4 L350.8,355.5 L361.0,349.3 L360.9,349.7Z M332.9,349.1 L336.2,349.4 L334.5,352.2 L332.3,352.7 L332.5,349.4 L332.9,349.1Z M351.5,300.9 L353.7,303.0 L351.5,301.0 L351.5,300.9Z M340.0,309.0 L340.6,300.8 L345.2,303.0 L350.4,310.8 L347.3,310.2 L344.1,307.1 L341.8,309.3 L340.2,309.1 L340.0,309.0Z M352.4,302.9 L352.6,304.3 L349.8,305.4 L348.4,304.5 L351.3,304.4 L352.1,302.8 L352.4,302.9Z M356.6,305.9 L355.4,305.0 L356.5,305.6 L356.6,305.9Z M358.2,306.8 L357.8,306.2 L358.2,306.8Z M360.7,308.3 L359.4,307.3 L360.7,308.0 L360.7,308.3Z M361.7,308.0 L362.1,309.6 L361.5,308.1 L361.7,308.0Z M360.4,309.2 L361.5,310.0 L360.3,309.5 L360.4,309.2Z M362.4,310.6 L362.0,310.4 L362.4,310.6Z M342.0,312.6 L342.2,315.6 L343.8,316.4 L343.9,321.3 L346.0,323.0 L348.9,330.4 L346.3,337.3 L339.9,345.1 L335.4,347.1 L334.6,345.5 L332.7,346.7 L330.8,346.1 L330.1,342.3 L329.0,342.6 L329.6,340.8 L327.8,342.2 L330.0,339.0 L326.7,341.8 L326.3,338.8 L323.6,337.4 L317.8,338.4 L314.3,340.6 L306.5,341.6 L305.7,340.9 L307.4,337.7 L306.6,330.7 L307.8,330.2 L308.5,325.3 L316.5,322.4 L319.4,318.3 L319.8,319.6 L324.1,314.9 L326.8,316.5 L328.3,313.2 L330.6,312.7 L329.8,311.7 L334.8,312.6 L333.2,316.5 L338.0,319.8 L341.1,311.3 L341.7,312.4 L342.0,312.6Z M328.5,311.9 L328.2,311.7 L328.5,311.9Z M367.0,316.2 L366.8,316.0 L367.0,316.2Z",
};

// Fisher-Yates shuffle — genuinely uniform random, unlike the common
// `array.sort(() => Math.random() - 0.5)` trick, which is a well-known
// anti-pattern: sort algorithms aren't designed for random comparators,
// and the resulting bias can noticeably over/under-represent certain
// elements depending on their original position in the array.
const shuffle = (arr) => {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

// Curated "similar" countries for Hard mode, keyed by country code — not
// limited to visual flag resemblance. A group can also be similar for other
// reasons a player might genuinely mix them up, e.g. geographic closeness
// (the Baltic states) as well as flags that just look alike (Croatia/
// Slovenia/Slovakia). Lists are NOT continent-scoped on purpose — e.g.
// Burkina Faso, Cameroon, and Myanmar look alike despite being on three
// different continents. At runtime (see getHardModeCountries below) each
// list gets filtered down to whichever entries are actually in the current
// game's eligible pool, so a country from a continent you didn't select
// can never show up as an option — you just get fewer "genuinely similar"
// distractors that game.
const SIMILAR_COUNTRIES = {
  // North America
  ag: ["ki", "pg", "tl", "gy", "lc"], // Antigua and Barbuda
  bs: ["bb", "ua", "cz", "se"], // Bahamas
  bb: ["bs", "ua", "lc", "pw"], // Barbados
  bz: ["li", "la", "kh"], // Belize
  ca: ["pe", "lb", "at", "dk", "tn"], // Canada
  cr: ["th", "kp", "nl", "fr", "py"], // Costa Rica
  cu: ["ph", "cl", "lr"], // Cuba
  dm: ["gd", "vc", "jm", "br", "km"], // Dominica
  do: ["pa", "cr", "ht", "no"], // Dominican Republic
  sv: ["ni", "hn", "gt", "ar", "gr"], // El Salvador
  gd: ["dm", "vc", "jm", "br", "gy"], // Grenada
  gt: ["sv", "hn", "ni", "ar", "sm"], // Guatemala
  ht: ["li", "bz", "do", "ec"], // Haiti
  hn: ["sv", "ni", "gt", "ar", "gr"], // Honduras
  jm: ["tz", "sb", "za", "gd", "vu"], // Jamaica
  mx: ["it", "hu", "pe", "gt", "py"], // Mexico
  ni: ["sv", "hn", "gt", "ar", "gr"], // Nicaragua
  pa: ["do", "cz", "us", "nl"], // Panama
  kn: ["tz", "cg", "na", "sb", "gy"], // Saint Kitts and Nevis
  lc: ["bb", "ua", "pw", "bs", "kz"], // Saint Lucia
  vc: ["dm", "gd", "jm", "br", "ga"], // Saint Vincent and the Grenadines
  tt: ["tz", "cg", "na", "pg", "kn"], // Trinidad and Tobago
  us: ["lr", "my", "cl", "uy"], // United States
  // South America
  ar: ["uy", "sv", "hn", "gt", "ni"], // Argentina
  bo: ["gh", "et", "mm", "sn", "lt"], // Bolivia
  br: ["sb", "jm", "za", "dm", "vc"], // Brazil
  cl: ["lr", "cu", "cz", "us", "uy"], // Chile
  co: ["ec", "ve", "am", "lt", "ua"], // Colombia
  ec: ["co", "ve", "am", "ad", "md"], // Ecuador
  gy: ["mz", "vu", "zw", "za", "jm"], // Guyana
  py: ["nl", "hr", "lu", "fr", "us"], // Paraguay
  pe: ["ca", "at", "lv", "co", "mx"], // Peru
  sr: ["bf", "vn", "gh", "cm", "mm"], // Suriname
  uy: ["ar", "gr", "lr", "us", "sv"], // Uruguay
  ve: ["ec", "co", "ad", "md", "am"], // Venezuela
  // Europe
  al: ["me", "kg", "mk", "cn", "xk"], // Albania
  ad: ["md", "ro", "td", "es", "li"], // Andorra
  at: ["lv", "lb", "pe", "id", "mc"], // Austria
  by: ["om", "mg", "tm"], // Belarus
  be: ["de", "td", "ro", "gn", "ml"], // Belgium
  ba: ["mh", "ua"], // Bosnia and Herzegovina
  bg: ["hu", "it", "ir", "tj", "lb"], // Bulgaria
  hr: ["rs", "sk", "nl", "py", "si"], // Croatia
  cy: ["dz", "mt", "gr", "il", "xk"], // Cyprus
  cz: ["ph", "dj", "cl", "sk", "cu"], // Czechia
  dk: ["ch", "no", "se", "fi", "is"], // Denmark
  ee: ["bw", "sm", "sl", "ls", "ar"], // Estonia
  fi: ["gr", "sm", "ee", "se", "is"], // Finland
  fr: ["it", "ie", "nl", "ro", "lu"], // France
  de: ["be", "ug", "ao", "mw", "eg"], // Germany
  gr: ["uy", "fi", "il", "lr", "so"], // Greece
  hu: ["bg", "it", "ir", "tj", "lb"], // Hungary
  is: ["no", "dk", "fi", "se", "gb"], // Iceland
  ie: ["ci", "it", "in", "ng", "mx"], // Ireland
  it: ["mx", "ie", "hu", "ci", "gn"], // Italy
  xk: ["al", "rs", "me", "mk", "cy"], // Kosovo — geographically similar (Balkans)
  lv: ["at", "qa", "bh", "lb", "pe"], // Latvia
  li: ["sm", "cz", "mc"], // Liechtenstein
  lt: ["mm", "gh", "co", "bo", "et"], // Lithuania
  lu: ["nl", "py", "hr", "fr", "ru"], // Luxembourg
  mt: ["pl", "id", "mc", "sm", "ch"], // Malta
  md: ["ro", "ad", "td", "ec", "co"], // Moldova
  mc: ["id", "pl", "sg", "mt"], // Monaco
  me: ["al", "mk", "es", "rs", "xk"], // Montenegro
  nl: ["lu", "ru", "py", "hr", "fr"], // Netherlands
  mk: ["kg", "jp", "vn", "xk"], // North Macedonia
  no: ["is", "dk", "gb", "se", "fi"], // Norway
  pl: ["id", "mc", "sg", "at", "mt"], // Poland
  pt: ["bd", "by", "mx", "it", "ma"], // Portugal
  ro: ["td", "md", "ad", "be", "fr"], // Romania
  ru: ["sk", "si", "rs", "nl", "fr"], // Russia
  sm: ["va", "mt", "mc", "ar", "fi"], // San Marino
  rs: ["sk", "si", "ru", "hr", "me", "xk"], // Serbia
  sk: ["si", "ru", "rs", "hr", "cz"], // Slovakia
  si: ["sk", "ru", "rs", "hr", "sm"], // Slovenia
  es: ["ad", "md", "ec", "pt", "co"], // Spain
  se: ["fi", "ua", "pw", "dk", "no"], // Sweden
  ch: ["to", "dk", "mt", "no"], // Switzerland
  ua: ["se", "bb", "kz", "pw", "rw"], // Ukraine
  gb: ["au", "nz", "is", "no", "tv"], // United Kingdom
  va: ["sm", "mt", "ad", "ch"], // Vatican City
  // Africa
  dz: ["pk", "mr", "tn", "tr", "ly"], // Algeria
  ao: ["mz", "tl", "vn", "de"], // Angola
  bj: ["gw", "mg", "tg", "bf", "cg"], // Benin
  bw: ["ee", "ar", "so", "sl"], // Botswana
  bf: ["vn", "gw", "gh", "sr", "ao"], // Burkina Faso
  bi: ["gd", "rw", "ke"], // Burundi
  cv: ["tv", "fm", "mh", "nr"], // Cabo Verde
  cm: ["sn", "ml", "gn", "gh", "cg"], // Cameroon
  cf: ["cr", "th", "ss", "mu"], // Central African Republic
  td: ["ro", "md", "ad", "be", "ml"], // Chad
  km: ["gy", "ss", "st", "mu", "sc"], // Comoros
  cd: ["sb", "tz", "na", "kn", "mh"], // Democratic Republic of the Congo
  dj: ["cz", "ph", "gq", "jo"], // Djibouti
  eg: ["sy", "iq", "ye", "sd", "ae"], // Egypt
  gq: ["ls", "dj", "gm", "uz", "sm"], // Equatorial Guinea
  er: ["dj", "gy", "cz", "ps"], // Eritrea
  sz: ["gm", "th", "cr", "bw"], // Eswatini
  et: ["bo", "gh", "sn", "mm", "ml"], // Ethiopia
  ga: ["sl", "uz", "in", "ne", "co"], // Gabon
  gm: ["sz", "cr", "th", "bw", "am"], // Gambia
  gh: ["bo", "sn", "cm", "et", "gn"], // Ghana
  gn: ["ml", "sn", "cm", "gh", "ci"], // Guinea
  gw: ["bj", "gh", "bf", "cv"], // Guinea-Bissau
  ci: ["ie", "it", "ne", "in", "gn"], // Ivory Coast
  ke: ["ss", "mw", "zm", "et", "zw"], // Kenya
  ls: ["sl", "uz", "sm", "ga", "ar"], // Lesotho
  lr: ["us", "my", "cl", "uy"], // Liberia
  ly: ["az", "dz", "mr", "tn", "ae"], // Libya
  mg: ["bj", "om", "by", "dz", "bg"], // Madagascar
  mw: ["ke", "ss", "af", "ug"], // Malawi
  ml: ["gn", "sn", "cm", "gh", "ci"], // Mali
  mr: ["pk", "tn", "tr", "sa"], // Mauritania
  mu: ["cf", "sc", "za", "am", "gm"], // Mauritius
  ma: ["vn", "tn", "tr", "sr", "mr"], // Morocco
  mz: ["zw", "ss", "gy", "vu", "tl"], // Mozambique
  na: ["sb", "cd", "tz", "kn", "mh"], // Namibia
  ne: ["in", "ci", "ie", "ga"], // Niger
  ng: ["pk", "sa", "ie", "ci", "pe"], // Nigeria
  cg: ["kn", "tz", "gy", "bj"], // Republic of the Congo
  rw: ["kz", "ga", "co", "uz", "ls"], // Rwanda
  st: ["gh", "gy", "gw", "tg", "bj"], // Sao Tome and Principe
  sn: ["ml", "cm", "gn", "gh", "et"], // Senegal
  sc: ["km", "mu", "zw", "za", "mh"], // Seychelles
  sl: ["ga", "uz", "ls", "sm", "ee"], // Sierra Leone
  so: ["fm", "vn", "ma", "il"], // Somalia
  za: ["vu", "ss", "jm", "zw", "ke"], // South Africa
  ss: ["ke", "sd", "mz", "jo", "ps"], // South Sudan
  sd: ["ps", "jo", "ae", "kw", "iq"], // Sudan
  tz: ["sb", "cg", "na", "kn", "tt"], // Tanzania
  tg: ["lr", "gr", "gw", "bj", "gh"], // Togo
  tn: ["tr", "dz", "sg"], // Tunisia
  ug: ["de", "ao", "be", "mw", "eg"], // Uganda
  zm: ["dm", "vc", "lk", "za", "gh"], // Zambia
  zw: ["mz", "za", "gy", "ss", "et"], // Zimbabwe
  // Asia
  af: ["sa", "iq", "pk", "dz"], // Afghanistan
  am: ["co", "ec", "ve", "ga", "lt"], // Armenia
  az: ["tr", "ly", "tm", "uz", "tn"], // Azerbaijan
  bh: ["qa", "lv", "ae", "mt", "jp"], // Bahrain
  bd: ["jp", "pw", "la", "ne", "vn"], // Bangladesh
  bt: ["lk", "np"], // Bhutan
  bn: ["co", "ec", "tl", "br"], // Brunei
  kh: ["la", "th", "bz", "es", "lb"], // Cambodia
  cn: ["vn", "kg", "kp", "tr", "ma"], // China
  ge: ["mt", "ch", "gb"], // Georgia
  in: ["ne", "ie", "ci", "tj", "hu"], // India
  id: ["mc", "pl", "sg", "pe", "mt"], // Indonesia
  ir: ["tj", "hu", "it", "mx", "bg"], // Iran
  iq: ["sy", "ye", "eg", "sd", "ae"], // Iraq
  il: ["gr", "hn", "ar", "sv", "so"], // Israel
  jp: ["bd", "pw", "kr", "la", "tw"], // Japan
  jo: ["ps", "ae", "kw", "sd", "iq"], // Jordan
  kz: ["pw", "ua", "se", "rw", "so"], // Kazakhstan
  kw: ["ae", "jo", "ps", "sd", "iq"], // Kuwait
  kg: ["vn", "tn", "al"], // Kyrgyzstan
  la: ["bz", "kh", "th", "ne", "jp"], // Laos
  lb: ["at", "pe", "ca", "by", "lv"], // Lebanon
  my: ["lr", "us", "uy", "cl"], // Malaysia
  mv: ["mr", "pk", "tr", "dz", "bd"], // Maldives
  mn: ["kz", "kg", "np", "bt", "cn"], // Mongolia
  mm: ["lt", "gh", "et", "bo", "sr"], // Myanmar
  np: ["ch", "bt", "in", "bd", "lk"], // Nepal
  kp: ["cr", "th", "la", "cu"], // North Korea
  om: ["by", "ae", "bg", "mg", "hu"], // Oman
  pk: ["mr", "tr", "tn", "dz", "az"], // Pakistan
  ps: ["jo", "sd", "ae", "kw"], // Palestine
  ph: ["cz", "cu", "dj", "gq", "cl", "tw"], // Philippines
  qa: ["bh", "lv", "ae", "om", "sg"], // Qatar
  sa: ["mr", "pk", "tm", "iq", "dz"], // Saudi Arabia
  sg: ["id", "mc", "pl", "tn", "tr"], // Singapore
  kr: ["mn", "kp", "jp", "np", "pw"], // South Korea
  lk: ["bt", "in", "mm", "np", "kh"], // Sri Lanka
  sy: ["iq", "ye", "eg", "sd", "ae"], // Syria
  tw: ["jp", "ph", "vn", "ws", "to"], // Taiwan — geographically similar (East/Southeast Asia)
  tj: ["ir", "hu", "it", "bg"], // Tajikistan
  th: ["cr", "kp", "nl", "fr", "sr"], // Thailand
  tl: ["ao", "mz", "gy", "pg", "vu"], // Timor-Leste
  tr: ["tn", "az", "sg", "pk", "dz"], // Turkey
  tm: ["pk", "by", "sa", "tr", "om"], // Turkmenistan
  ae: ["jo", "ps", "kw", "sd", "om"], // United Arab Emirates
  uz: ["tj", "az", "tm", "km", "kz"], // Uzbekistan
  vn: ["cn", "so", "ma", "bf", "kg", "tw"], // Vietnam
  ye: ["eg", "iq", "sy", "sd"], // Yemen
  // Oceania
  au: ["nz", "tv", "fj", "gb", "ws"], // Australia
  fj: ["tv", "au", "nz", "gb"], // Fiji
  ki: ["ag", "uy", "ar", "mw"], // Kiribati
  mh: ["nr", "fm", "pw", "cd"], // Marshall Islands
  fm: ["so", "pw", "vn", "il"], // Micronesia
  nr: ["mh", "pw", "fm"], // Nauru
  nz: ["au", "tv", "fj", "gb", "ws"], // New Zealand
  pw: ["bd", "jp", "kz", "se", "fm"], // Palau
  pg: ["tl", "tt", "sb", "ws", "ao"], // Papua New Guinea
  ws: ["mm", "cl", "lr", "to", "tw"], // Samoa
  sb: ["tz", "na", "cd", "kn", "br"], // Solomon Islands
  to: ["ch", "ge", "dk", "tw"], // Tonga
  tv: ["fj", "au", "nz", "gb"], // Tuvalu
  vu: ["za", "mz", "jm", "gy", "zw"], // Vanuatu
};

const getHardModeCountries = (correctCountry, pool, excludeCode) => {
  const similarCodes = SIMILAR_COUNTRIES[correctCountry.code] || [];
  const poolCodes = new Set(pool.map((c) => c.code));
  const availableSimilar = similarCodes
    .filter((code) => code !== excludeCode && poolCodes.has(code))
    .map((code) => pool.find((c) => c.code === code));

  let options = [correctCountry, ...shuffle(availableSimilar).slice(0, 2)];

  // Not enough curated similar countries actually in play this game (e.g.
  // a small or unrelated continent selection) — top up with random
  // distractors the same way easy mode does, rather than falling short.
  let attempts = 0;
  while (options.length < 3 && options.length < pool.length && attempts < 200) {
    attempts++;
    const randomCountry = pool[Math.floor(Math.random() * pool.length)];
    const alreadyIncluded = options.some((o) => o.code === randomCountry.code);
    const isExcluded = excludeCode && randomCountry.code === excludeCode;
    if (!alreadyIncluded && !isExcluded) {
      options.push(randomCountry);
    }
  }

  return shuffle(options);
};

// If too much of the selected pool lacks enough curated similar-country
// data (fewer than 2 same-pool matches), Hard mode would quietly degrade
// into "secretly Easy mode" for a big chunk of questions — e.g. picking
// South America or Oceania alone. This checks the CURRENT pool (whatever
// continents are selected right now), not a hardcoded list of continents,
// so it stays accurate if the similar-country data is expanded later.
const HARD_MODE_FALLBACK_THRESHOLD = 0.45;

const getHardModeFallbackRate = (pool) => {
  if (pool.length === 0) return 0;
  const poolCodes = new Set(pool.map((c) => c.code));
  let needingFallback = 0;
  pool.forEach((c) => {
    const availableSimilar = (SIMILAR_COUNTRIES[c.code] || []).filter((code) =>
      poolCodes.has(code)
    );
    if (availableSimilar.length < 2) needingFallback++;
  });
  return needingFallback / pool.length;
};

const getRandomCountries = (correctCountry, pool, excludeCode) => {
  let options = [correctCountry];
  let attempts = 0;
  const maxAttempts = 200;

  // First pass: fill distractors while avoiding the previous question's
  // answer, so it never reappears as an option immediately after.
  while (options.length < 3 && options.length < pool.length && attempts < maxAttempts) {
    attempts++;
    const randomCountry = pool[Math.floor(Math.random() * pool.length)];
    const alreadyIncluded = options.some((o) => o.code === randomCountry.code);
    const isExcluded = excludeCode && randomCountry.code === excludeCode;
    if (!alreadyIncluded && !isExcluded) {
      options.push(randomCountry);
    }
  }

  // Fallback: if the pool is too small to fill 3 options while excluding
  // the previous answer (e.g. a tiny continent selection), drop that
  // constraint rather than get stuck with fewer than 3 options.
  while (options.length < 3 && options.length < pool.length) {
    const randomCountry = pool[Math.floor(Math.random() * pool.length)];
    if (!options.some((o) => o.code === randomCountry.code)) {
      options.push(randomCountry);
    }
  }

  return shuffle(options);
};

export default function FlagQuiz() {
  // Dark mode: defaults to the OS/browser's prefers-color-scheme unless
  // the player has explicitly toggled it before (remembered in
  // localStorage). If they've never overridden it, a live listener keeps
  // following the system setting even while the page stays open.
  const THEME_STORAGE_KEY = "gtf_theme";
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY);
      if (stored === "light" || stored === "dark") return stored;
    } catch (err) {
      // localStorage unavailable — fall through to system preference.
    }
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => {
    let hasExplicitPreference = false;
    try {
      hasExplicitPreference = localStorage.getItem(THEME_STORAGE_KEY) !== null;
    } catch (err) {
      hasExplicitPreference = false;
    }
    if (hasExplicitPreference || !window.matchMedia) return;

    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => setTheme(e.matches ? "dark" : "light");
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next);
    } catch (err) {
      // Best-effort — theme still works for this session even if it
      // can't be remembered for next time.
    }
  };

  // Level 1: multiple choice, easy. Level 2: multiple choice, hard.
  // Level 3: typed answer (difficulty doesn't apply). mode is derived
  // from this single source of truth so the rest of the component
  // (rendering, etc.) barely needs to know levels exist. Option
  // generation reads levelRef.current directly instead (see below) rather
  // than a derived difficulty value here.
  const [level, setLevel] = useState(1);
  const mode = level === 3 ? "text" : "multiple";
  const [started, setStarted] = useState(false);
  const [showChangelog, setShowChangelog] = useState(false);
  const [showCelebrations, setShowCelebrations] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [statsData, setStatsData] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsError, setStatsError] = useState(false);
  const [countryStatsFilter, setCountryStatsFilter] = useState("all");
  const [countryStatsSortBy, setCountryStatsSortBy] = useState("passRate"); // "passRate" | "name"
  const [countryStatsSortDir, setCountryStatsSortDir] = useState("desc"); // "asc" | "desc"
  const [previewBadgeKey, setPreviewBadgeKey] = useState(null);
  const [selectStep, setSelectStep] = useState("continents"); // "continents" | "count"
  const [selectedContinents, setSelectedContinents] = useState(
    () => new Set(CONTINENTS)
  );
  const [quizSet, setQuizSet] = useState([]);
  const [eligiblePool, setEligiblePool] = useState([]);
  const [remainingCountries, setRemainingCountries] = useState([]);
  const [currentCountry, setCurrentCountry] = useState(null);
  const [options, setOptions] = useState([]);
  const [score, setScore] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [feedback, setFeedback] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [typedValue, setTypedValue] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const textInputRef = useRef(null);
  const imgRef = useRef(null);
  const flagBoxRef = useRef(null);
  const previousCountryCodeRef = useRef(null);
  const prevRemainingLengthRef = useRef(0);
  const replayClickCountRef = useRef(0);
  const replayClickTimeoutRef = useRef(null);
  const questionStartTimeRef = useRef(null);
  const sessionIdRef = useRef(null);
  if (sessionIdRef.current === null) {
    sessionIdRef.current = getOrCreateSessionId();
  }
  const logCompletedGameRef = useRef(() => {});
  const buildCelebrationPiecesRef = useRef(() => null);
  const isAnsweringRef = useRef(false);

  // Fetches the aggregate stats fresh — called explicitly whenever the
  // Stats screen is opened (see the footer's onClick below), rather than
  // being tied to a useEffect that only fetched once per session. This
  // means reopening the screen always shows current numbers instead of
  // whatever was cached from the first visit.
  const fetchStats = () => {
    setStatsLoading(true);
    setStatsError(false);
    fetch("/api/stats")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load stats");
        return res.json();
      })
      .then((data) => {
        setStatsData(data);
        setStatsLoading(false);
      })
      .catch(() => {
        setStatsError(true);
        setStatsLoading(false);
      });
  };
  const levelRef = useRef(level);
  const currentQuestionLevelRef = useRef(level);

  useEffect(() => {
    levelRef.current = level;
  }, [level]);
  const [imgRect, setImgRect] = useState(null);
  const [confettiPieces, setConfettiPieces] = useState([]);
  const [correctPulse, setCorrectPulse] = useState(false);
  const scoreRowRef = useRef(null);
  const gameTopRowRef = useRef(null);
  const [pauseButtonCompact, setPauseButtonCompact] = useState(false);
  const [scoreRowStacked, setScoreRowStacked] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [wasAutoPaused, setWasAutoPaused] = useState(false);
  const pauseStartRef = useRef(null);
  const autoPauseTimeoutRef = useRef(null);
  const [incorrectPulse, setIncorrectPulse] = useState(false);
  const [answerLog, setAnswerLog] = useState([]);
  const [questionFilter, setQuestionFilter] = useState("all"); // "all" | "correct" | "incorrect"
  const [sliderCount, setSliderCount] = useState(10);
  useEffect(() => {
    setSliderCount(10);
  }, [selectedContinents]);

  // Kicks off a game: filters the full list down to the selected continents,
  // then samples `count` countries at random from that filtered pool (or all
  // of them if `count` is "all" or exceeds what's available).
  const startGame = (count, continents) => {
    const eligible = countries.filter((c) => continents.has(c.continent));
    const pool = shuffle(eligible);
    const n = count === "all" ? pool.length : Math.min(count, pool.length);
    const selected = pool.slice(0, n);
    setEligiblePool(eligible);
    setQuizSet(selected);
    setRemainingCountries(selected);
    setScore(0);
    setAttempts(0);
    setAnswerLog([]);
    setQuestionFilter("all");
    previousCountryCodeRef.current = null;
    isAnsweringRef.current = false;
    setIsPaused(false);
    pauseStartRef.current = null;
    setScoreRowStacked(false);
    setPauseButtonCompact(false);
    setWasAutoPaused(false);
    setStarted(true);
  };

  // Bypasses continent/count/mode selection entirely: 20 questions, every
  // continent, multiple choice (level 1) — a one-tap way into a game.
  const quickStart = () => {
    const allContinents = new Set(CONTINENTS);
    setSelectedContinents(allContinents);
    setSliderCount(20);
    setLevel(1);
    startGame(20, allContinents);
  };

  const toggleContinent = (continent) => {
    setSelectedContinents((prev) => {
      const next = new Set(prev);
      if (next.has(continent)) {
        next.delete(continent);
      } else {
        next.add(continent);
      }
      return next;
    });
  };

  // Uses the live current continent selection, not the eligiblePool state
  // (which only updates when startGame actually runs, so it's stale while
  // still on the setup screens choosing continents).
  const currentSelectionPool = countries.filter((c) =>
    selectedContinents.has(c.continent)
  );
  const eligibleCountryCount = currentSelectionPool.length;
  const hardModeFallbackRate = getHardModeFallbackRate(currentSelectionPool);
  const hardModeDisabled = hardModeFallbackRate >= HARD_MODE_FALLBACK_THRESHOLD;

  // Safety net: if the player has Hard selected and then goes back and
  // changes their continent selection to something Hard mode doesn't
  // support well, drop back to Easy rather than leaving them stuck on a
  // now-disabled option.
  useEffect(() => {
    if (level === 2 && hardModeDisabled) {
      setLevel(1);
    }
  }, [hardModeDisabled, level]);

  useEffect(() => {
    if (remainingCountries.length > 0) {
      // remainingCountries is already randomly shuffled once at game start,
      // so just take them in order rather than drawing a fresh random pick
      // each time — this lets us know exactly which flag is coming up next.
      const nextCountry = remainingCountries[0];
      const previousCode = previousCountryCodeRef.current;
      setCurrentCountry(nextCountry);
      // Reads level via a ref, captured once per question, rather than the
      // reactive `level` state directly — so switching Easy/Hard mid-
      // question never regenerates the current question's options (which
      // would risk exposing the answer); the new level only takes effect
      // starting from the next question.
      const effectiveDifficulty = levelRef.current === 2 ? "hard" : "easy";
      currentQuestionLevelRef.current = effectiveDifficulty === "hard" ? 2 : 1;
      setOptions(
        effectiveDifficulty === "hard"
          ? getHardModeCountries(nextCountry, eligiblePool, previousCode)
          : getRandomCountries(nextCountry, eligiblePool, previousCode)
      );
      previousCountryCodeRef.current = nextCountry.code;
      setImgError(false);
      setImgRect(null);
      setTypedValue("");
      setHighlightedIndex(-1);
      questionStartTimeRef.current = Date.now();
      // Only now — with the new question's country/options/timer all set
      // up — is it safe to accept another answer. Releasing this any
      // earlier (e.g. right when the old feedback clears) leaves a brief
      // gap where a rapid spam-click could still land against the old
      // question and double-count it.
      isAnsweringRef.current = false;

      // Fresh inactivity countdown for the new question — auto-pauses if
      // it sits unanswered too long. Clear any stale one first in case
      // this effect re-runs for another reason.
      if (autoPauseTimeoutRef.current) clearTimeout(autoPauseTimeoutRef.current);
      autoPauseTimeoutRef.current = setTimeout(
        () => triggerPause(true),
        AUTO_PAUSE_DELAY_MS
      );

      // Preload the flag image for the *following* question now, while
      // this one is still being shown/answered, so by the time the player
      // advances it's already cached and swaps in instantly instead of
      // showing the just-answered flag for a moment while it loads.
      const upcoming = remainingCountries[1];
      if (upcoming) {
        const preloadImg = new window.Image();
        preloadImg.src = `${FLAG_CDN_URL}/${upcoming.code.toLowerCase()}.png`;
      }
    }
  }, [remainingCountries, eligiblePool]);

  // Keep the text input focused on mobile: re-focus it whenever a new flag
  // loads, or when switching into text mode, so the on-screen keyboard
  // stays up without the player needing to tap back into the field.
  useEffect(() => {
    if (mode === "text" && textInputRef.current) {
      textInputRef.current.focus();
    }
  }, [currentCountry, mode]);

  // Scrolls the flag near the top of whatever viewport space remains once
  // the on-screen keyboard is open, with a small buffer above it. The
  // visualViewport "resize" event fires when the mobile keyboard actually
  // finishes animating open/closed, which is more reliable than guessing a
  // fixed delay. Falls back to a short timeout for browsers without it.
  useEffect(() => {
    if (mode !== "text") return;

    const scrollFlagIntoView = () => {
      if (!flagBoxRef.current) return;
      const buffer = 16;
      const top =
        flagBoxRef.current.getBoundingClientRect().top + window.scrollY - buffer;
      window.scrollTo({ top, behavior: "smooth" });
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scrollFlagIntoView);
      return () =>
        window.visualViewport.removeEventListener("resize", scrollFlagIntoView);
    }
    const fallbackTimer = setTimeout(scrollFlagIntoView, 300);
    return () => clearTimeout(fallbackTimer);
  }, [mode, currentCountry]);

  // Measures the actual rendered size of the flag image, so the feedback
  // overlay can be sized to match the visible flag exactly rather than the
  // full fixed-height layout box around it. Re-measures on window resize
  // since the box's max-width means the rendered size is responsive.
  const measureImg = () => {
    if (imgRef.current) {
      const rect = imgRef.current.getBoundingClientRect();
      setImgRect({ width: rect.width, height: rect.height });
    }
  };

  useEffect(() => {
    window.addEventListener("resize", measureImg);
    return () => window.removeEventListener("resize", measureImg);
  }, []);

  // Keeps the score row (Correct lozenge / donut / Incorrect lozenge) on
  // one line, matching the original layout, but falls back to a stacked
  // layout if it genuinely doesn't fit — e.g. a device with larger system
  // font scaling or browser zoom. Measures the REAL row's own rendered
  // height (it already has flexWrap: wrap as a safety net, so wrapping
  // shows up as extra height) rather than comparing against a separate
  // hidden probe element — an earlier version of this used a hidden
  // absolutely-positioned probe to measure scrollWidth/clientWidth, but
  // that consistently under-reported overflow (likely due to how some
  // mobile browsers apply font-boosting differently to hidden/absolutely
  // positioned elements than to normally-flowed visible ones). Measuring
  // the actual displayed element sidesteps that entirely, since there's
  // no second copy that could diverge from what's really on screen.
  const SCORE_ROW_SINGLE_LINE_MAX_HEIGHT = 70;
  const checkScoreRowOverflow = () => {
    if (!scoreRowRef.current) return;
    const el = scoreRowRef.current;
    setScoreRowStacked(el.offsetHeight > SCORE_ROW_SINGLE_LINE_MAX_HEIGHT);
  };
  // Read via a ref rather than calling the closure directly from the
  // effect below — the closure is recreated every render (it captures
  // score/attempts/etc.), and listing it as a dependency would force the
  // effect to tear down and recreate its listener/interval on every
  // render too. The ref always points at the latest version, and the
  // effect's own 500ms poll picks up fresh score/attempts values
  // automatically, so the effect itself only needs to run once.
  const checkScoreRowOverflowRef = useRef(() => {});
  useEffect(() => {
    checkScoreRowOverflowRef.current = checkScoreRowOverflow;
  });

  useEffect(() => {
    const check = () => checkScoreRowOverflowRef.current();
    check();
    window.addEventListener("resize", check);
    // Browser/OS zoom and font-scaling mechanisms don't reliably fire a
    // window resize event in every case, so relying on that alone can
    // miss the exact case we care about. Polling is inelegant but
    // guarantees correctness regardless of which zoom mechanism a given
    // browser/OS uses; the cost of checking offsetHeight every 500ms is
    // negligible.
    const intervalId = setInterval(check, 500);
    return () => {
      window.removeEventListener("resize", check);
      clearInterval(intervalId);
    };
  }, []);

  // Same idea as the score row above, for the difficulty toggle + Pause
  // button row: if it's about to wrap, drop the Pause/Resume button down
  // to icon-only first, which is usually enough on its own to avoid a
  // full wrap. This is a ONE-WAY ratchet (compact never reverts back to
  // full-text reactively) rather than mirroring the score row's
  // freely-reversible approach — hiding the text changes this row's own
  // width, the very thing being measured, so a reactive "un-compact if it
  // fits now" check would immediately re-trigger wrapping and flicker
  // between states every poll. Resets to full-text at the start of each
  // new game instead (see startGame).
  const GAME_TOP_ROW_SINGLE_LINE_MAX_HEIGHT = 55;
  const checkGameTopRowOverflow = () => {
    if (!gameTopRowRef.current || pauseButtonCompact) return;
    const el = gameTopRowRef.current;
    if (el.offsetHeight > GAME_TOP_ROW_SINGLE_LINE_MAX_HEIGHT) {
      setPauseButtonCompact(true);
    }
  };
  const checkGameTopRowOverflowRef = useRef(() => {});
  useEffect(() => {
    checkGameTopRowOverflowRef.current = checkGameTopRowOverflow;
  });

  useEffect(() => {
    const check = () => checkGameTopRowOverflowRef.current();
    check();
    window.addEventListener("resize", check);
    const intervalId = setInterval(check, 500);
    return () => {
      window.removeEventListener("resize", check);
      clearInterval(intervalId);
    };
  }, []);

  // Countries whose name starts with what's been typed so far
  // (case-insensitive), used to drive the autocomplete suggestion list in
  // text mode. Alternate names/abbreviations (e.g. "UK") are intentionally
  // not matched here — only the actual displayed country name.
  const suggestions =
    typedValue.trim().length === 0
      ? []
      : eligiblePool.filter((c) =>
          c.name.toLowerCase().startsWith(typedValue.trim().toLowerCase())
        );

  // Shared by both manual pausing (the Pause button) and automatic
  // pausing (20s of inactivity) — the underlying mechanism is identical,
  // only the `auto` flag differs, which just controls the wording shown
  // on the paused screen.
  const triggerPause = (auto) => {
    pauseStartRef.current = Date.now();
    setWasAutoPaused(auto);
    setIsPaused(true);
  };

  // Pausing only shifts the *current question's* timer, by moving its
  // recorded start time forward by however long the pause lasted — so
  // "time taken" calculations elsewhere never need to know pausing
  // happened at all. Disallowed during the brief feedback flash, since
  // the auto-advance-to-next-question timer keeps running in the
  // background regardless of pause state, and pausing mid-flash could
  // cause the question to change while the pause screen is still showing.
  const handlePause = () => {
    if (feedback) return;
    if (autoPauseTimeoutRef.current) clearTimeout(autoPauseTimeoutRef.current);
    triggerPause(false);
  };

  const handleResume = () => {
    if (pauseStartRef.current && questionStartTimeRef.current) {
      const pausedDurationMs = Date.now() - pauseStartRef.current;
      questionStartTimeRef.current += pausedDurationMs;
    }
    pauseStartRef.current = null;
    setIsPaused(false);
    // The current question is still unanswered, so give it a fresh
    // inactivity window rather than picking up wherever the (cleared)
    // countdown left off.
    if (!feedback) {
      autoPauseTimeoutRef.current = setTimeout(
        () => triggerPause(true),
        AUTO_PAUSE_DELAY_MS
      );
    }
  };

  const handleGuess = (guess) => {
    // Guard against a question being counted twice. This uses a ref, not
    // just the `feedback` state check below, because state updates aren't
    // synchronous — if two clicks happen fast enough (e.g. two different
    // option buttons tapped in quick succession before React re-renders
    // with the buttons disabled), both clicks can read `feedback` as still
    // null from their own closures and both slip through a state-only
    // guard. A ref updates immediately, so the second click is reliably
    // blocked regardless of render timing.
    if (feedback || isAnsweringRef.current) return;
    isAnsweringRef.current = true;
    if (autoPauseTimeoutRef.current) clearTimeout(autoPauseTimeoutRef.current);

    setAttempts((prev) => prev + 1);

    const isCorrect = guess.name === currentCountry.name;
    const timeTakenMs = questionStartTimeRef.current
      ? Date.now() - questionStartTimeRef.current
      : 0;
    // For typed answers, the current level is always accurate (typed mode
    // has no pre-generated options to go stale). For multiple choice,
    // log whichever level the *displayed* options were actually built
    // under, in case Easy/Hard was switched mid-question — that switch
    // only takes effect from the next question, so the log should match
    // what was really on screen, not just whatever the toggle currently
    // shows.
    const loggedLevel = mode === "text" ? 3 : currentQuestionLevelRef.current;
    setAnswerLog((prev) => [
      ...prev,
      {
        code: currentCountry.code,
        name: currentCountry.name,
        continent: currentCountry.continent,
        correct: isCorrect,
        userAnswer: guess.name,
        userAnswerCode: guess.code,
        timeTakenMs,
        level: loggedLevel,
      },
    ]);

    if (isCorrect) {
      setScore((prev) => prev + 1);
      setFeedback("Correct");
      setCorrectPulse(true);
      setTimeout(() => setCorrectPulse(false), 500);
    } else {
      setFeedback(`Incorrect\nThe correct answer was ${currentCountry.name}`);
      setIncorrectPulse(true);
      setTimeout(() => setIncorrectPulse(false), 500);
    }

    setTimeout(() => {
      setRemainingCountries((prev) =>
        prev.filter((c) => c.code !== currentCountry.code)
      );
      setFeedback(null);
      // Deliberately NOT releasing isAnsweringRef here — see the
      // next-question effect below, which releases it only once the new
      // question is actually ready. Releasing it here instead would leave
      // a brief gap (between this state update committing and that effect
      // running) where a rapid spam-click could slip through and
      // double-count the *old* question.
    }, ANSWER_FEEDBACK_DELAY_MS);
  };

  // Finds a country in the eligible pool whose full name or a known alias
  // exactly matches the given (already trimmed/lowercased) query. Used to
  // gate Enter/Go submission so a partial, unfinished guess never counts.
  const getExactMatch = (query) => {
    if (!query) return null;
    return eligiblePool.find((c) => {
      if (c.name.toLowerCase() === query) return true;
      return (countryAliases[c.code] || []).some(
        (alias) => alias.toLowerCase() === query
      );
    });
  };

  // Shared submit logic for text mode, used by both the Enter key and the
  // Go button. Only submits on an exact match of the full country name or a
  // known alias (e.g. "UK", "USA") — a partial prefix never auto-submits,
  // even if it happens to narrow the suggestion list down to one entry.
  const attemptSubmitTyped = () => {
    if (feedback) return;
    const match = getExactMatch(typedValue.trim().toLowerCase());
    if (match) handleGuess(match);
  };

  // Fire-and-forget: posts the completed game (summary + per-question
  // detail) to the logging endpoint. Wrapped so a network failure, a
  // missing endpoint, or anything else here can never affect gameplay —
  // worst case, that one game just doesn't get logged.
  const logCompletedGame = () => {
    try {
      const levelCounts = { 1: 0, 2: 0, 3: 0 };
      answerLog.forEach((a) => {
        levelCounts[a.level] = (levelCounts[a.level] || 0) + 1;
      });
      const durationMs = answerLog.reduce(
        (sum, a) => sum + (a.timeTakenMs || 0),
        0
      );

      const payload = {
        sessionId: sessionIdRef.current,
        score,
        attempts,
        quizSize: quizSet.length,
        continents: Array.from(selectedContinents),
        durationMs,
        levelSummary: levelCounts,
        answers: answerLog.map((a) => ({
          code: a.code,
          continent: a.continent,
          correct: a.correct,
          level: a.level,
          timeTakenMs: a.timeTakenMs,
          userAnswerCode: a.userAnswerCode,
        })),
      };

      fetch("/api/log-game", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).catch(() => {});
    } catch (err) {
      // Never let a logging error affect gameplay.
    }
  };

  // Keeps logCompletedGameRef pointing at the current render's closure
  // (with the latest score/attempts/answerLog/etc.), so the completion
  // effect below can call it via the ref without needing to list it as a
  // dependency — which would otherwise force that effect to re-run on
  // every render instead of only at the actual game-finished transition.
  useEffect(() => {
    logCompletedGameRef.current = logCompletedGame;
  });

  useEffect(() => {
    buildCelebrationPiecesRef.current = buildCelebrationPieces;
  });

  // Perfect-score / zero-score celebration: fires exactly once, at the
  // precise moment the quiz transitions from "playing" (remainingCountries
  // non-empty) to "finished" (remainingCountries empty) — not on every
  // re-render that happens to see a matching score/attempts snapshot, which
  // is what previously caused this to misfire. The transition is tracked
  // via a ref rather than a "have we fired yet" state flag, since a ref
  // update can't itself trigger extra effect re-runs.
  // Builds the celebration piece set (and its display duration) for a
  // given result — pulled out as its own function so it can be called
  // both automatically when a game finishes and manually via the hidden
  // replay trigger on the results screen (see resultsPercentageWrap's
  // onClick below).
  const buildCelebrationPieces = (resultScore, resultAttempts, resultQuizSet, resultAnswerLog) => {
    const isPerfect = resultScore === resultAttempts;
    const isZero = resultScore === 0;
    const isFullList = resultQuizSet.length === countries.length;
    if (!isPerfect && !isZero && !isFullList) return null;

    const fullPerfectTier = getResultBadgeKey(
      resultScore,
      resultAttempts,
      resultQuizSet.length,
      resultAnswerLog
    );

    const emojiPool =
      resultQuizSet.length > 0
        ? resultQuizSet
        : eligiblePool.length > 0
        ? eligiblePool
        : countries;
    const randomFlag = () =>
      getFlagEmoji(emojiPool[Math.floor(Math.random() * emojiPool.length)].code);
    const makeMixedPiece = (i, extras) => ({
      id: i,
      emoji:
        Math.random() < 0.2 ? extras[Math.floor(Math.random() * extras.length)] : randomFlag(),
      left: Math.random() * 100,
      size: 20 + Math.random() * 24,
      duration: 2.5 + Math.random() * 2.5,
      delay: Math.random() * 0.8,
      rotation: Math.random() < 0.5 ? 360 : -360,
    });

    let pieces;
    let duration = 5500;

    if (isZero) {
      // Zero score is never something to celebrate, even on a full-list
      // attempt — takes priority over every completion/perfect tier.
      pieces = Array.from({ length: 40 }, (_, i) => ({
        id: i,
        emoji: "😢",
        left: Math.random() * 100,
        size: 20 + Math.random() * 16,
        duration: 2.5 + Math.random() * 2,
        delay: Math.random() * 0.6,
        rotation: Math.random() < 0.5 ? 360 : -360,
      }));
    } else if (isFullList && isPerfect && fullPerfectTier === "gold") {
      pieces = Array.from({ length: 150 }, (_, i) =>
        makeMixedPiece(i, ["🥇", "🏆", "👑"])
      );
      duration = 7000;
    } else if (isFullList && isPerfect && fullPerfectTier === "silver") {
      pieces = Array.from({ length: 120 }, (_, i) => makeMixedPiece(i, ["🥈"]));
      duration = 7000;
    } else if (isFullList && isPerfect) {
      // bronze
      pieces = Array.from({ length: 120 }, (_, i) => makeMixedPiece(i, ["🥉"]));
      duration = 7000;
    } else if (isPerfect) {
      // Perfect score, but not the full list — unchanged from before.
      pieces = Array.from({ length: 60 }, (_, i) => ({
        id: i,
        emoji: randomFlag(),
        left: Math.random() * 100,
        size: 20 + Math.random() * 20,
        duration: 2.5 + Math.random() * 2,
        delay: Math.random() * 0.6,
        rotation: Math.random() < 0.5 ? 360 : -360,
      }));
    } else {
      // Completion: full list played, not a perfect score.
      pieces = Array.from({ length: 60 }, (_, i) => ({
        id: i,
        emoji: "🌍",
        left: Math.random() * 100,
        size: 20 + Math.random() * 18,
        duration: 2.5 + Math.random() * 2,
        delay: Math.random() * 0.6,
        rotation: Math.random() < 0.5 ? 360 : -360,
      }));
    }

    return { pieces, duration };
  };

  // Hidden replay: three clicks within 1.5s on the results screen's
  // percentage ring re-triggers whatever celebration tier the current
  // result qualifies for — handy for demoing without replaying a whole
  // game, especially the 197-question tiers.
  const handleResultsRingClick = () => {
    replayClickCountRef.current += 1;
    if (replayClickTimeoutRef.current) clearTimeout(replayClickTimeoutRef.current);

    if (replayClickCountRef.current >= 3) {
      replayClickCountRef.current = 0;
      const result = buildCelebrationPieces(score, attempts, quizSet, answerLog);
      if (result) {
        setConfettiPieces(result.pieces);
        setTimeout(() => setConfettiPieces([]), result.duration);
      }
      return;
    }

    replayClickTimeoutRef.current = setTimeout(() => {
      replayClickCountRef.current = 0;
    }, 1500);
  };

  useEffect(() => {
    const wasPlaying = prevRemainingLengthRef.current > 0;
    const justFinished = wasPlaying && remainingCountries.length === 0;
    prevRemainingLengthRef.current = remainingCountries.length;

    if (!started || !justFinished || attempts === 0) return;

    logCompletedGameRef.current();

    const result = buildCelebrationPiecesRef.current(score, attempts, quizSet, answerLog);
    if (!result) return;

    setConfettiPieces(result.pieces);
    const clearTimer = setTimeout(() => setConfettiPieces([]), result.duration);
    return () => clearTimeout(clearTimer);
  }, [remainingCountries, started, attempts, score, quizSet, eligiblePool, answerLog]);

  const backToSelectScreen = () => {
    setStarted(false);
    setSelectStep("continents");
    setIsPaused(false);
    pauseStartRef.current = null;
    if (autoPauseTimeoutRef.current) clearTimeout(autoPauseTimeoutRef.current);
  };

  const siteFooter = (
    <p style={styles.attribution}>
      guesstheflag.games
      <br />
      © {new Date().getFullYear()}{" "}
      <a
        href="https://giddings.games"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.attributionLink}
      >
        giddings.games
      </a>{" "}
      <FlagIcon size={12} />
      <br />
      Flag images{" "}
      <a
        href="https://flagpedia.net"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.attributionLink}
      >
        Flagpedia
      </a>
      {" · Icons "}
      <a
        href="https://fontawesome.com"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.attributionLink}
      >
        Font Awesome
      </a>
      <br />
      <button
        style={styles.footerLinkButton}
        onClick={() => setShowChangelog(true)}
      >
        Changelog
      </button>
      {" · "}
      <button
        style={styles.footerLinkButton}
        onClick={() => {
          setShowStats(true);
          fetchStats();
        }}
      >
        Stats
      </button>
      {" · v"}
      {CHANGELOG[0].version}
    </p>
  );

  // Extracted so both the results screen and the celebrations preview
  // screen can show it, without duplicating this block.
  const confettiOverlayJSX = confettiPieces.length > 0 && (
    <div style={styles.confettiOverlay} aria-hidden="true">
      <style>{`
        @keyframes flagConfettiFall {
          0% { transform: translateY(-10vh) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh) rotate(var(--confetti-rotation)); opacity: 0.9; }
        }
      `}</style>
      {confettiPieces.map((piece) => (
        <span
          key={piece.id}
          style={{
            position: "absolute",
            top: 0,
            left: `${piece.left}%`,
            fontSize: `${piece.size}px`,
            animationName: "flagConfettiFall",
            animationDuration: `${piece.duration}s`,
            animationDelay: `${piece.delay}s`,
            animationTimingFunction: "linear",
            animationFillMode: "forwards",
            "--confetti-rotation": `${piece.rotation}deg`,
          }}
        >
          {piece.emoji}
        </span>
      ))}
    </div>
  );

  if (showChangelog) {
    return (
      <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
        <button
          style={styles.changelogCloseButton}
          onClick={() => setShowChangelog(false)}
          aria-label="Close changelog"
        >
          <TimesIcon size={14} />
        </button>
        <h1
          style={styles.title}
          onClick={() => setShowChangelog(false)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setShowChangelog(false);
          }}
        >
          Guess the flag
        </h1>
        <h2 style={styles.resultsSubtitle}>Changelog</h2>
        <div style={styles.changelogList}>
          {CHANGELOG.map((entry) => (
            <div key={entry.version} style={styles.changelogEntry}>
              <div style={styles.changelogEntryHeader}>
                <span style={styles.changelogVersion}>v{entry.version}</span>
                <span style={styles.changelogTitle}>{entry.title}</span>
              </div>
              <ul style={styles.changelogItemList}>
                {entry.items.map((item, i) => (
                  <li key={i} style={styles.changelogItem}>
                    {item}
                  </li>
                ))}
                {entry.version === "1.16" && (
                  <li style={styles.changelogItem}>
                    Added a new Celebrations preview screen showing every
                    badge and confetti tier on demand, without needing to
                    actually play, and win, 197 questions to see them.{" "}
                    <button
                      style={styles.footerLinkButton}
                      onClick={() => {
                        setShowChangelog(false);
                        setShowCelebrations(true);
                      }}
                    >
                      Preview it here
                    </button>
                    .
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>
        <button
          style={styles.backButtonSpaced}
          onClick={() => setShowChangelog(false)}
        >
          Back
        </button>
        {siteFooter}
      </div>
    );
  }

  if (showCelebrations) {
    // Synthetic result data for each tier, built from the real countries
    // list so flag emoji render correctly — this screen calls the exact
    // same buildCelebrationPieces/getResultBadgeKey functions the real
    // results screen uses, just with made-up scores instead of a real
    // game, so it can never drift out of sync with the actual celebration
    // logic.
    const previewTiers = [
      {
        key: "completion",
        label: "Completion — full list, not perfect",
        score: 182,
        attempts: 197,
        quizSet: countries,
        answerLog: [{ level: 1 }],
      },
      {
        key: "bronze",
        label: "Bronze — 197/197, Easy or mixed",
        score: 197,
        attempts: 197,
        quizSet: countries,
        answerLog: [{ level: 1 }, { level: 2 }],
      },
      {
        key: "silver",
        label: "Silver — 197/197, all Hard or higher",
        score: 197,
        attempts: 197,
        quizSet: countries,
        answerLog: [{ level: 2 }, { level: 3 }],
      },
      {
        key: "gold",
        label: "Gold — 197/197, all Pro",
        score: 197,
        attempts: 197,
        quizSet: countries,
        answerLog: [{ level: 3 }],
      },
      {
        key: "perfect",
        label: "Perfect score, smaller quiz — no badge",
        score: 20,
        attempts: 20,
        quizSet: countries.slice(0, 20),
        answerLog: [{ level: 2 }],
      },
      {
        key: "zero",
        label: "Zero score",
        score: 0,
        attempts: 20,
        quizSet: countries.slice(0, 20),
        answerLog: [],
      },
    ];

    const triggerPreview = (tier) => {
      const result = buildCelebrationPieces(
        tier.score,
        tier.attempts,
        tier.quizSet,
        tier.answerLog
      );
      setPreviewBadgeKey(
        getResultBadgeKey(tier.score, tier.attempts, tier.quizSet.length, tier.answerLog)
      );
      if (result) {
        setConfettiPieces(result.pieces);
        setTimeout(() => setConfettiPieces([]), result.duration);
      }
    };

    return (
      <div style={styles.quizContainer}>
        <style>{THEME_STYLE}</style>
        <button
          style={styles.themeToggle}
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        >
          {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
        </button>
        {confettiOverlayJSX}
        <button
          style={styles.changelogCloseButton}
          onClick={() => setShowCelebrations(false)}
          aria-label="Close celebrations preview"
        >
          <TimesIcon size={14} />
        </button>
        <h1
          style={styles.title}
          onClick={() => setShowCelebrations(false)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setShowCelebrations(false);
          }}
        >
          Guess the flag
        </h1>
        <h2 style={styles.resultsSubtitle}>Celebrations preview</h2>
        <p style={styles.changelogIntro}>
          A look at every badge and confetti tier the results screen can
          show, without needing to actually play (and win) 197 questions.
        </p>

        <div style={{ minHeight: "36px" }}>
          {previewBadgeKey && (
            <div style={styles.achievementBadgeWrap}>
              <span
                style={{
                  ...styles.achievementBadge,
                  backgroundColor: BADGE_INFO[previewBadgeKey].color,
                }}
              >
                {BADGE_INFO[previewBadgeKey].emoji} {BADGE_INFO[previewBadgeKey].label}
              </span>
            </div>
          )}
        </div>

        <div style={styles.celebrationPreviewList}>
          {previewTiers.map((tier) => (
            <button
              key={tier.key}
              style={styles.celebrationTierButton}
              onClick={() => triggerPreview(tier)}
            >
              {tier.label}
            </button>
          ))}
        </div>

        <button
          style={styles.backButtonSpaced}
          onClick={() => setShowCelebrations(false)}
        >
          Back
        </button>
        {siteFooter}
      </div>
    );
  }

  if (showStats) {
    return (
      <div style={styles.quizContainer}>
        <style>{THEME_STYLE}</style>
        <button
          style={styles.themeToggle}
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        >
          {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
        </button>
        <button
          style={styles.changelogCloseButton}
          onClick={() => setShowStats(false)}
          aria-label="Close stats"
        >
          <TimesIcon size={14} />
        </button>
        <h1
          style={styles.title}
          onClick={() => setShowStats(false)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setShowStats(false);
          }}
        >
          Guess the flag
        </h1>
        <h2 style={styles.resultsSubtitle}>Stats</h2>
        <p style={styles.changelogIntro}>
          A look at how the game's been played, across everyone, all
          time.
        </p>

        {statsLoading && (
          <p style={styles.changelogIntro}>Loading stats…</p>
        )}
        {statsError && (
          <p style={styles.changelogIntro}>
            Couldn't load stats right now. Try again in a moment.
          </p>
        )}
        {statsData && !statsLoading && !statsError && (
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {statsData.gamesPlayed.toLocaleString()}
              </div>
              <div style={styles.statLabel}>Games played</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {statsData.avgPercentage.toFixed(1)}%
              </div>
              <div style={styles.statLabel}>Average score</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {statsData.questionsServed.toLocaleString()}
              </div>
              <div style={styles.statLabel}>Questions served</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {statsData.celebrationsTriggered.toLocaleString()}
              </div>
              <div style={styles.statLabel}>Celebrations triggered</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {formatLongDuration(statsData.totalDurationMs)}
              </div>
              <div style={styles.statLabel}>Total time played</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>
                {formatDuration(statsData.avgQuestionTimeMs)}
              </div>
              <div style={styles.statLabel}>Average question time</div>
            </div>
          </div>
        )}
        {statsData && !statsLoading && !statsError && (
          <>
            <h3 style={styles.statsSectionTitle}>Difficulty breakdown</h3>
            <div style={styles.levelSplitList}>
              {[1, 2, 3].map((lvl) => {
                const data = statsData.levelSplit[lvl] || { count: 0, correct: 0 };
                const total = [1, 2, 3].reduce(
                  (sum, l) => sum + (statsData.levelSplit[l]?.count || 0),
                  0
                );
                const pctOfTotal =
                  total > 0 ? ((data.count / total) * 100).toFixed(1) : "0.0";
                const incorrect = data.count - data.correct;
                const correctPct =
                  data.count > 0 ? ((data.correct / data.count) * 100).toFixed(1) : "0.0";
                const incorrectPct =
                  data.count > 0 ? ((incorrect / data.count) * 100).toFixed(1) : "0.0";
                const gaugePct =
                  data.count > 0 ? Math.round((data.correct / data.count) * 100) : 0;
                return (
                  <div key={lvl} style={styles.levelBreakdownCard}>
                    <div style={styles.levelBreakdownGaugeWrap}>
                      <GaugeRing
                        percentage={gaugePct}
                        color={LEVEL_COLORS[lvl]}
                        size={64}
                        strokeWidth={7}
                      />
                    </div>
                    <div style={styles.levelBreakdownTextWrap}>
                      <div style={styles.levelBreakdownHeader}>
                        <span
                          style={{ ...styles.levelDot, backgroundColor: LEVEL_COLORS[lvl] }}
                        />
                        <span style={styles.levelBreakdownTitle}>{LEVEL_LABELS[lvl]}</span>
                      </div>
                      <div style={styles.levelBreakdownServed}>
                        {data.count.toLocaleString()} questions served, {pctOfTotal}% of total
                      </div>
                      <div style={styles.levelBreakdownResultsWrap}>
                        <div style={styles.levelBreakdownResultRow}>
                          <span style={{ color: "#28a745" }}>
                            <CheckIcon size={12} />
                          </span>
                          <span>
                            {data.correct.toLocaleString()} correct, {correctPct}%
                          </span>
                        </div>
                        <div style={styles.levelBreakdownResultRow}>
                          <span style={{ color: "#e74c3c" }}>
                            <TimesIcon size={12} />
                          </span>
                          <span>
                            {incorrect.toLocaleString()} incorrect, {incorrectPct}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <h3 style={styles.statsSectionTitle}>Country breakdown</h3>
            <div style={{ ...styles.filterPillRow, flexWrap: "wrap", marginBottom: "10px" }}>
              {["all", ...CONTINENTS].map((continent) => (
                <button
                  key={continent}
                  style={{
                    ...styles.filterPill,
                    ...(countryStatsFilter === continent ? styles.filterPillActive : {}),
                  }}
                  onClick={() => setCountryStatsFilter(continent)}
                >
                  {continent === "all" ? "All" : continent}
                </button>
              ))}
            </div>
            <div style={styles.countryListHeaderRow}>
              <button
                style={styles.countryListSortButton}
                onClick={() => {
                  if (countryStatsSortBy === "name") {
                    setCountryStatsSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
                  } else {
                    setCountryStatsSortBy("name");
                    setCountryStatsSortDir("asc");
                  }
                }}
              >
                Country
                {countryStatsSortBy === "name" && (
                  <>
                    {" "}
                    {countryStatsSortDir === "asc" ? (
                      <CaretUpIcon size={10} />
                    ) : (
                      <CaretDownIcon size={10} />
                    )}
                  </>
                )}
              </button>
              <button
                style={styles.countryListSortButton}
                onClick={() => {
                  if (countryStatsSortBy === "passRate") {
                    setCountryStatsSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
                  } else {
                    setCountryStatsSortBy("passRate");
                    setCountryStatsSortDir("desc");
                  }
                }}
              >
                Pass rate
                {countryStatsSortBy === "passRate" && (
                  <>
                    {" "}
                    {countryStatsSortDir === "asc" ? (
                      <CaretUpIcon size={10} />
                    ) : (
                      <CaretDownIcon size={10} />
                    )}
                  </>
                )}
              </button>
            </div>
            <div style={styles.questionList}>
              {statsData.countryStats
                .map((c) => {
                  const country = countries.find((co) => co.code === c.code);
                  return {
                    ...c,
                    name: country ? country.name : c.code.toUpperCase(),
                    continent: country ? country.continent : null,
                    pct: c.total > 0 ? Math.round((c.correct / c.total) * 100) : 0,
                  };
                })
                .filter(
                  (c) => countryStatsFilter === "all" || c.continent === countryStatsFilter
                )
                .sort((a, b) => {
                  if (countryStatsSortBy === "name") {
                    return countryStatsSortDir === "asc"
                      ? a.name.localeCompare(b.name)
                      : b.name.localeCompare(a.name);
                  }
                  return countryStatsSortDir === "asc" ? a.pct - b.pct : b.pct - a.pct;
                })
                .map((c) => (
                  <div key={c.code} style={styles.continentStatRow}>
                    <div style={styles.continentStatLabelRow}>
                      <span style={styles.continentStatName}>
                        {getFlagEmoji(c.code)} {c.name}
                      </span>
                      <span style={styles.continentStatCount}>
                        {c.correct}/{c.total} ({c.pct}%)
                      </span>
                    </div>
                    <div style={styles.continentStatBarTrack}>
                      <div
                        style={{
                          ...styles.continentStatBarFill,
                          width: `${c.pct}%`,
                          backgroundColor:
                            c.pct >= 80 ? "#28a745" : c.pct >= 50 ? "#f0ad4e" : "#e74c3c",
                        }}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}

        <button
          style={styles.backButtonSpaced}
          onClick={() => setShowStats(false)}
        >
          Back
        </button>
        {siteFooter}
      </div>
    );
  }

  if (!started && selectStep === "continents") {
    const noneSelected = selectedContinents.size === 0;
    return (
      <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
        <h1
          style={styles.title}
          onClick={backToSelectScreen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") backToSelectScreen();
          }}
        >
          Guess the flag
        </h1>
        <p style={styles.selectPrompt}>Which continents do you want to include?</p>
        <div style={styles.worldMapWrap}>
          <svg width="100%" viewBox={WORLD_MAP_VIEWBOX} style={styles.worldMapSvg}>
            {CONTINENTS.map((continent) => (
              <path
                key={continent}
                d={CONTINENT_SHAPES[continent]}
                onClick={() => toggleContinent(continent)}
                style={{
                  cursor: "pointer",
                  stroke: "var(--card-bg)",
                  strokeWidth: 0.5,
                  fill: selectedContinents.has(continent) ? "var(--accent)" : "var(--border-strong)",
                  transition: "fill 0.15s ease",
                }}
              >
                <title>{continent}</title>
              </path>
            ))}
          </svg>
        </div>
        <div style={styles.continentLegend}>
          {CONTINENTS.map((continent) => {
            const count = countries.filter((c) => c.continent === continent).length;
            const checked = selectedContinents.has(continent);
            return (
              <button
                key={continent}
                onClick={() => toggleContinent(continent)}
                style={{
                  ...styles.continentLegendItem,
                  ...(checked ? styles.continentLegendItemActive : {}),
                }}
              >
                <span
                  style={{
                    ...styles.continentLegendDot,
                    backgroundColor: checked ? "var(--accent)" : "var(--border-strong)",
                  }}
                />
                {continent}{" "}
                <span style={styles.continentCount}>({count})</span>
              </button>
            );
          })}
        </div>
        <div style={styles.continentToggleRow}>
          <button
            style={{
              ...styles.toggleChip,
              ...(selectedContinents.size === CONTINENTS.length
                ? styles.toggleChipDisabled
                : {}),
            }}
            disabled={selectedContinents.size === CONTINENTS.length}
            onClick={() => setSelectedContinents(new Set(CONTINENTS))}
          >
            <CheckIcon size={12} /> Select all
          </button>
          <button
            style={{
              ...styles.toggleChip,
              ...(noneSelected ? styles.toggleChipDisabled : {}),
            }}
            disabled={noneSelected}
            onClick={() => setSelectedContinents(new Set())}
          >
            <TimesIcon size={12} /> Select none
          </button>
        </div>
        {noneSelected && (
          <p style={styles.continentWarning}>
            Select at least one continent to continue.
          </p>
        )}
        <button
          style={{
            ...styles.countButton,
            ...(noneSelected ? styles.countButtonDisabled : {}),
          }}
          disabled={noneSelected}
          onClick={() => setSelectStep("count")}
        >
          <span style={styles.nextButtonLabel}>Next</span>
          {!noneSelected && (
            <span style={styles.countButtonNote}>
              {eligibleCountryCount} countries
            </span>
          )}
        </button>
        <button style={styles.quickStartButton} onClick={quickStart}>
          <span
            style={{
              ...styles.nextButtonLabel,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <BoltIcon size={14} /> Quick start
          </span>
          <span style={styles.countButtonNote}>
            20 flags, all countries, multiple choice
          </span>
        </button>
        {siteFooter}
      </div>
    );
  }

  if (!started && selectStep === "count") {
    const sliderMin = Math.min(10, eligibleCountryCount);
    const sliderMax = eligibleCountryCount;
    const clampedValue = Math.min(sliderCount, sliderMax);
    const isAll = clampedValue >= sliderMax;

    // Small unlabeled tick marks every 10, plus numeric labels only at a
    // few key points (min, every 50, and the max) — labeling every tick
    // would be unreadable at this range on a phone screen.
    const ticks = [];
    for (let v = sliderMin; v <= sliderMax; v += 10) ticks.push(v);
    if (ticks[ticks.length - 1] !== sliderMax) ticks.push(sliderMax);

    return (
      <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
        <style>{`
          .flag-quiz-slider {
            -webkit-appearance: none;
            appearance: none;
            width: 100%;
            height: 6px;
            border-radius: 3px;
            background: var(--border-light);
            outline: none;
          }
          .flag-quiz-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: var(--accent);
            border: 3px solid var(--card-bg);
            box-shadow: 0 1px 4px rgba(0,0,0,0.3);
            cursor: pointer;
            margin-top: -10px;
          }
          .flag-quiz-slider::-moz-range-thumb {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: var(--accent);
            border: 3px solid var(--card-bg);
            box-shadow: 0 1px 4px rgba(0,0,0,0.3);
            cursor: pointer;
          }
          .flag-quiz-slider::-moz-range-track {
            height: 6px;
            border-radius: 3px;
            background: var(--border-light);
          }
        `}</style>
        <h1
          style={styles.title}
          onClick={backToSelectScreen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") backToSelectScreen();
          }}
        >
          Guess the flag
        </h1>
        <p style={styles.selectPrompt}>How many flags do you want to guess?</p>

        <div style={styles.sliderValueDisplay}>
          {isAll ? `All ${sliderMax} flags` : `${clampedValue} flags`}
        </div>

        <div style={styles.sliderWrap}>
          <input
            type="range"
            className="flag-quiz-slider"
            min={sliderMin}
            max={sliderMax}
            step={1}
            value={clampedValue}
            onChange={(e) => {
              const raw = Number(e.target.value);
              // Snap to the nearest valid step (increments of 10, with the
              // exact max always reachable as the final "All" step even
              // when it isn't itself a multiple of 10).
              const nearest = ticks.reduce((best, tick) =>
                Math.abs(tick - raw) < Math.abs(best - raw) ? tick : best
              );
              setSliderCount(nearest);
            }}
            onClick={(e) => {
              // Chrome/Firefox already jump to the clicked position on a
              // native range input by default, but WebKit/Safari
              // specifically only responds to dragging the thumb itself —
              // clicking elsewhere on the track does nothing there. This
              // computes the click's position explicitly so it works the
              // same way on every browser, Safari included.
              const rect = e.currentTarget.getBoundingClientRect();
              const fraction = Math.min(
                1,
                Math.max(0, (e.clientX - rect.left) / rect.width)
              );
              const raw = sliderMin + fraction * (sliderMax - sliderMin);
              const nearest = ticks.reduce((best, tick) =>
                Math.abs(tick - raw) < Math.abs(best - raw) ? tick : best
              );
              setSliderCount(nearest);
            }}
          />
          <div style={styles.sliderTicks}>
            {ticks.map((tick) => (
              <div
                key={tick}
                style={{
                  ...styles.sliderTick,
                  left: `${((tick - sliderMin) / (sliderMax - sliderMin)) * 100}%`,
                }}
              />
            ))}
          </div>
          <div style={styles.sliderLabels}>
            <span>{sliderMin}</span>
            <span>All ({sliderMax})</span>
          </div>
        </div>

        <button
          style={styles.countButton}
          onClick={() => setSelectStep("mode")}
        >
          <span style={styles.nextButtonLabel}>Next</span>
          <span style={styles.countButtonNote}>
            {clampedValue} flags from {eligibleCountryCount} countries
          </span>
        </button>
        <button
          style={styles.backButtonSpaced}
          onClick={() => setSelectStep("continents")}
        >
          Back
        </button>
        {siteFooter}
      </div>
    );
  }

  if (!started && selectStep === "mode") {
    const sliderMax = eligibleCountryCount;
    const clampedValue = Math.min(sliderCount, sliderMax);

    return (
      <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
        <h1
          style={styles.title}
          onClick={backToSelectScreen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") backToSelectScreen();
          }}
        >
          Guess the flag
        </h1>
        <p style={styles.selectPrompt}>Select your difficulty</p>

        <div style={styles.modeScreenToggle}>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 1
                ? {
                    backgroundColor: LEVEL_COLORS[1],
                    border: `1px solid ${LEVEL_COLORS[1]}`,
                    color: "white",
                  }
                : {}),
            }}
            onClick={() => setLevel(1)}
          >
            {LEVEL_LABELS[1]}
          </button>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 2
                ? {
                    backgroundColor: LEVEL_COLORS[2],
                    border: `1px solid ${LEVEL_COLORS[2]}`,
                    color: "white",
                  }
                : {}),
              ...(hardModeDisabled ? styles.modeScreenChipDisabled : {}),
            }}
            disabled={hardModeDisabled}
            onClick={() => setLevel(2)}
            title={
              hardModeDisabled
                ? "Not enough similar-country data for this continent selection. Hard mode would end up too close to Easy mode."
                : undefined
            }
          >
            {LEVEL_LABELS[2]}
          </button>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 3
                ? {
                    backgroundColor: LEVEL_COLORS[3],
                    border: `1px solid ${LEVEL_COLORS[3]}`,
                    color: "white",
                  }
                : {}),
            }}
            onClick={() => setLevel(3)}
          >
            {LEVEL_LABELS[3]}
          </button>
        </div>
        {hardModeDisabled && (
          <p style={styles.modeScreenNote}>
            Hard mode isn't available for this continent selection. Not
            enough similar countries within it to make it meaningfully
            different from Easy.
          </p>
        )}
        <p style={{ ...styles.modeScreenDescription, marginBottom: "12px" }}>
          {level === 1 &&
            "Multiple choice, pick the correct country from 3 randomly chosen options."}
          {level === 2 &&
            "Multiple choice, pick the correct country from 3 similar countries, visually or geographically. A tougher test."}
          {level === 3 &&
            "Type the country name yourself. Autocomplete suggestions help you answer faster."}
        </p>
        <p style={styles.modeScreenNote}>
          You can switch this anytime during the game too.
        </p>

        <button
          style={styles.countButton}
          onClick={() => startGame(clampedValue, selectedContinents)}
        >
          <span style={styles.nextButtonLabel}>Start game</span>
          <span style={styles.countButtonNote}>
            {clampedValue} flags from {eligibleCountryCount} countries,{" "}
            {level === 1 && "easy"}
            {level === 2 && "hard"}
            {level === 3 && "pro"}
          </span>
        </button>
        <button
          style={styles.backButtonSpaced}
          onClick={() => setSelectStep("count")}
        >
          Back
        </button>
        {siteFooter}
      </div>
    );
  }

  if (remainingCountries.length === 0) {
    const percentage = attempts > 0 ? Math.round((score / attempts) * 100) : 0;
    const percentageColor =
      percentage >= 80 ? "#28a745" : percentage >= 50 ? "#f0ad4e" : "#e74c3c";

    // Total/average time is the sum of each question's individual
    // flag-shown-to-guess-submitted duration — this naturally excludes the
    // feedback overlay delay entirely, since that only happens afterward.
    const totalTimeMs = answerLog.reduce((sum, a) => sum + (a.timeTakenMs || 0), 0);
    const avgTimeMs = attempts > 0 ? totalTimeMs / attempts : 0;

    // Per-continent breakdown, only worth showing if more than one
    // continent actually appeared in this game.
    const continentsPlayed = [...new Set(answerLog.map((a) => a.continent))];
    const continentStats = continentsPlayed
      .map((continent) => {
        const entries = answerLog.filter((a) => a.continent === continent);
        const correctCount = entries.filter((a) => a.correct).length;
        return {
          continent,
          correct: correctCount,
          total: entries.length,
          pct: entries.length > 0 ? Math.round((correctCount / entries.length) * 100) : 0,
        };
      })
      .sort((a, b) => b.pct - a.pct);

    // Breakdown of which answer level was actually used per question,
    // shown as a lozenge per level actually played (so a game played
    // entirely on one level just shows one lozenge, not an empty pie).
    const levelCounts = { 1: 0, 2: 0, 3: 0 };
    answerLog.forEach((a) => {
      levelCounts[a.level] = (levelCounts[a.level] || 0) + 1;
    });
    const levelStats = [1, 2, 3]
      .map((lvl) => ({ level: lvl, count: levelCounts[lvl] }))
      .filter((s) => s.count > 0);

    const isPerfectScore = attempts > 0 && score === attempts;
    const isFullListScore = quizSet.length === countries.length;
    const resultBadgeKey = getResultBadgeKey(score, attempts, quizSet.length, answerLog);
    const levelSummaryText =
      levelStats.length === 1
        ? `${LEVEL_LABELS[levelStats[0].level]} mode`
        : "mixed difficulty";
    const continentsSummaryText =
      continentsPlayed.length === CONTINENTS.length
        ? "all continents"
        : continentsPlayed.join(", ");
    const shareText = `I scored ${score}/${attempts} (${percentage}%)${
      isFullListScore && isPerfectScore
        ? ` ${BADGE_INFO[resultBadgeKey].emoji}`
        : isPerfectScore
        ? " 💯🏆"
        : ""
    } on Guess the flag 🏁 (${levelSummaryText}, ${continentsSummaryText}). Can you beat me? https://guesstheflag.games`;

    const handleShare = async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title: "Guess the flag", text: shareText });
        } catch (e) {
          // User cancelled the share sheet, or it failed silently — nothing
          // to do either way.
        }
        return;
      }
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(shareText);
          setShareCopied(true);
          setTimeout(() => setShareCopied(false), 2000);
        } catch (e) {
          // Clipboard write can fail (e.g. permissions) — fail quietly.
        }
      }
    };

    // Keep original question numbers attached before filtering, so "Q7"
    // still says 7 even when only incorrect answers are shown.
    const numberedLog = answerLog.map((entry, index) => ({
      ...entry,
      questionNumber: index + 1,
    }));
    const filteredLog = numberedLog.filter((entry) => {
      if (questionFilter === "correct") return entry.correct;
      if (questionFilter === "incorrect") return !entry.correct;
      return true;
    });

    return (
      <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
        {confettiOverlayJSX}
        <h1
          style={styles.title}
          onClick={backToSelectScreen}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") backToSelectScreen();
          }}
        >
          Guess the flag
        </h1>
        <h2 style={styles.resultsSubtitle}>Your results</h2>
        {(() => {
          if (!resultBadgeKey) return null;
          const badge = BADGE_INFO[resultBadgeKey];
          return (
            <div style={styles.achievementBadgeWrap}>
              <span
                style={{ ...styles.achievementBadge, backgroundColor: badge.color }}
              >
                {badge.emoji} {badge.label}
              </span>
            </div>
          );
        })()}

        <div style={styles.resultsPercentageWrap} onClick={handleResultsRingClick}>
          <svg width="120" height="120" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="52" fill="none" stroke="var(--border-light)" strokeWidth="10" />
            <circle
              cx="60"
              cy="60"
              r="52"
              fill="none"
              stroke={percentageColor}
              strokeWidth="10"
              strokeLinecap="round"
              strokeDasharray={2 * Math.PI * 52}
              strokeDashoffset={2 * Math.PI * 52 * (1 - percentage / 100)}
              transform="rotate(-90 60 60)"
            />
            <text
              x="60"
              y="68"
              textAnchor="middle"
              fontSize="28"
              fontWeight="800"
              fill={percentageColor}
            >
              {percentage}%
            </text>
          </svg>
        </div>

        <div style={styles.scoreContainer}>
          <span style={{ ...styles.lozenge, backgroundColor: "#28a745" }}>
            Correct: {score}
          </span>
          <span style={{ ...styles.lozenge, backgroundColor: "#e74c3c" }}>
            Incorrect: {attempts - score}
          </span>
        </div>

        <div style={styles.timeStatsRow}>
          <span style={styles.timeLozenge}>
            Total time: {formatDuration(totalTimeMs)}
          </span>
          <span style={styles.timeLozenge}>
            Avg: {(avgTimeMs / 1000).toFixed(1)}s
          </span>
        </div>

        {continentsPlayed.length > 1 && (
          <div style={styles.resultsSection}>
            <h3 style={styles.resultsSectionTitle}>Continent breakdown</h3>
            <div style={styles.continentStatsList}>
              {continentStats.map((stat) => (
                <div key={stat.continent} style={styles.continentStatRow}>
                  <div style={styles.continentStatLabelRow}>
                    <span style={styles.continentStatName}>{stat.continent}</span>
                    <span style={styles.continentStatCount}>
                      {stat.correct}/{stat.total}
                    </span>
                  </div>
                  <div style={styles.continentStatBarTrack}>
                    <div
                      style={{
                        ...styles.continentStatBarFill,
                        width: `${stat.pct}%`,
                        backgroundColor:
                          stat.pct >= 80
                            ? "#28a745"
                            : stat.pct >= 50
                            ? "#f0ad4e"
                            : "#e74c3c",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={styles.resultsSection}>
          <h3 style={styles.resultsSectionTitle}>Difficulty breakdown</h3>
          <div style={styles.timeStatsRow}>
            {levelStats.map((stat) => (
              <span
                key={stat.level}
                style={{
                  ...styles.timeLozenge,
                  backgroundColor: LEVEL_COLORS[stat.level],
                }}
              >
                {LEVEL_LABELS[stat.level]}: {stat.count} (
                {Math.round((stat.count / answerLog.length) * 100)}%)
              </span>
            ))}
          </div>
        </div>

        <div style={styles.resultsSection}>
          <div style={styles.questionBreakdownHeaderRow}>
            <h3 style={styles.resultsSectionTitle}>Question breakdown</h3>
            <div style={styles.filterPillRow}>
              {[
                { key: "all", label: "All" },
                { key: "correct", label: "Correct" },
                { key: "incorrect", label: "Incorrect" },
              ].map((option) => (
                <button
                  key={option.key}
                  style={{
                    ...styles.filterPill,
                    ...(questionFilter === option.key
                      ? styles.filterPillActive
                      : {}),
                  }}
                  onClick={() => setQuestionFilter(option.key)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
          <div style={styles.questionList}>
            {filteredLog.length === 0 ? (
              <p style={styles.questionListEmpty}>
                {questionFilter === "correct" ? (
                  <span style={styles.questionListEmptyContent}>
                    <SadCryIcon size={16} /> Oh dear… nothing to filter
                  </span>
                ) : questionFilter === "incorrect" ? (
                  <span style={styles.questionListEmptyContent}>
                    <TrophyIcon size={16} /> Nothing to filter… champion
                  </span>
                ) : (
                  "No questions match this filter."
                )}
              </p>
            ) : (
              filteredLog.map((entry) => (
                <div
                  key={`${entry.code}-${entry.questionNumber}`}
                  style={{
                    ...styles.questionRow,
                    backgroundColor: entry.correct
                      ? "rgba(40, 167, 69, 0.08)"
                      : "rgba(231, 76, 60, 0.08)",
                  }}
                >
                  <span style={styles.questionRowNumber}>
                    {entry.questionNumber}
                  </span>
                  <span style={styles.questionRowEmoji}>
                    {getFlagEmoji(entry.code)}
                  </span>
                  <span style={styles.questionRowName}>
                    {entry.name}
                    {!entry.correct && (
                      <span style={styles.questionRowUserAnswer}>
                        You said: {entry.userAnswer}
                      </span>
                    )}
                  </span>
                  <span
                    style={{
                      ...styles.levelDot,
                      backgroundColor: LEVEL_COLORS[entry.level],
                    }}
                    title={LEVEL_LABELS[entry.level]}
                  />
                  <span style={styles.questionRowTime}>
                    {(entry.timeTakenMs / 1000).toFixed(1)}s
                  </span>
                  <span
                    style={{
                      ...styles.questionRowIcon,
                      color: entry.correct ? "#28a745" : "#e74c3c",
                    }}
                  >
                    {entry.correct ? <CheckIcon size={13} /> : <TimesIcon size={13} />}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        <button style={styles.playAgain} onClick={backToSelectScreen}>
          Play again
        </button>
        <button style={styles.shareButton} onClick={handleShare}>
          {shareCopied ? "Copied to clipboard!" : "Share results"}
        </button>
        <button
          style={styles.shareButton}
          onClick={() => {
            setShowStats(true);
            fetchStats();
          }}
        >
          View stats
        </button>
        {siteFooter}
      </div>
    );
  }

  return (
    <div style={styles.quizContainer}>
      <style>{THEME_STYLE}</style>
      <button
        style={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      >
        {theme === "dark" ? <SunIcon size={16} /> : <MoonIcon size={16} />}
      </button>
      <h1
        style={styles.title}
        onClick={backToSelectScreen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") backToSelectScreen();
        }}
      >
        Guess the flag
      </h1>
      <div ref={gameTopRowRef} style={styles.gameTopRow}>
        <div style={styles.modeToggle}>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 1
                ? {
                    backgroundColor: LEVEL_COLORS[1],
                    border: `1px solid ${LEVEL_COLORS[1]}`,
                    color: "white",
                  }
                : {}),
            }}
            onClick={() => setLevel(1)}
          >
            {LEVEL_LABELS[1]}
          </button>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 2
                ? {
                    backgroundColor: LEVEL_COLORS[2],
                    border: `1px solid ${LEVEL_COLORS[2]}`,
                    color: "white",
                  }
                : {}),
            }}
            onClick={() => setLevel(2)}
          >
            {LEVEL_LABELS[2]}
          </button>
          <button
            style={{
              ...styles.modeButton,
              ...(level === 3
                ? {
                    backgroundColor: LEVEL_COLORS[3],
                    border: `1px solid ${LEVEL_COLORS[3]}`,
                    color: "white",
                  }
                : {}),
            }}
            onClick={() => setLevel(3)}
          >
            {LEVEL_LABELS[3]}
          </button>
        </div>
        <button
          style={styles.pauseButton}
          onClick={isPaused ? handleResume : handlePause}
          disabled={!isPaused && !!feedback}
          aria-label={isPaused ? "Resume" : "Pause"}
        >
          <span style={styles.pauseButtonContent}>
            {isPaused ? <PlayIcon size={12} /> : <PauseIcon size={12} />}
            {!pauseButtonCompact && (isPaused ? "Resume" : "Pause")}
          </span>
        </button>
      </div>
      {isPaused ? (
        <div style={styles.pausedBox}>
          <div style={styles.pausedIcon}>
            <PauseIcon size={40} />
          </div>
          <p style={styles.pausedTitle}>
            {wasAutoPaused ? "Auto-paused" : "Paused"}
          </p>
          <p style={styles.pausedNote}>
            {wasAutoPaused
              ? "This question sat unanswered for a while, so we paused for you. The timer's stopped, take your time. The flag and answers are hidden until you resume."
              : "The timer's stopped, take your time. The flag and answers are hidden until you resume."}
          </p>
          <button
            style={{ ...styles.playAgain, margin: "16px auto 0" }}
            onClick={handleResume}
          >
            Resume
          </button>
        </div>
      ) : (
        <>
      <div style={styles.flagContainer}>
        <div ref={flagBoxRef} style={styles.flagBox}>
          {currentCountry && !imgError && (
            <img
              key={currentCountry.code}
              ref={imgRef}
              src={`${FLAG_CDN_URL}/${currentCountry.code.toLowerCase()}.png`}
              alt="Flag to identify"
              style={styles.flagImage}
              onLoad={measureImg}
              onError={() => setImgError(true)}
            />
          )}
          {currentCountry && imgError && (
            <div style={styles.flagFallback}>
              <span style={styles.flagFallbackNotice}>
                Live flag image unavailable
                <br />
                Showing emoji instead
              </span>
              <span style={styles.flagEmoji}>
                {getFlagEmoji(currentCountry.code)}
              </span>
            </div>
          )}
          {feedback && (
            <div
              style={{
                ...styles.flagOverlay,
                borderRadius: imgError ? "4px" : "0px",
                ...(imgError || !imgRect
                  ? { top: 0, left: 0, width: "100%", height: "100%" }
                  : {
                      top: "50%",
                      left: "50%",
                      width: `${imgRect.width}px`,
                      height: `${imgRect.height}px`,
                      transform: "translate(-50%, -50%)",
                    }),
                ...(feedback.startsWith("Correct")
                  ? styles.flagOverlayCorrect
                  : styles.flagOverlayWrong),
              }}
            >
              {feedback.includes("\n") ? (
                <div style={styles.overlayLines}>
                  <span>{feedback.split("\n")[0]}</span>
                  <span style={styles.overlaySecondLine}>
                    {feedback.split("\n")[1]}
                  </span>
                </div>
              ) : (
                feedback
              )}
            </div>
          )}
        </div>
      </div>
      {mode === "multiple" ? (
        <div style={styles.options}>
          {options.map((option) => (
            <button
              key={option.code}
              disabled={!!feedback}
              style={{
                ...styles.optionButton,
                fontSize: getOptionButtonFontSize(option.name),
                backgroundColor:
                  feedback && option.name === currentCountry.name ? "green" : "#444",
                cursor: feedback ? "default" : "pointer",
                opacity: feedback && option.name !== currentCountry.name ? 0.6 : 1,
              }}
              onClick={() => handleGuess(option)}
            >
              {option.name}
            </button>
          ))}
        </div>
      ) : (
        <div style={styles.textModeContainer}>
          <div style={styles.textInputRow}>
            <input
              ref={textInputRef}
              type="text"
              value={typedValue}
              readOnly={!!feedback}
              placeholder="Type a country name..."
              style={styles.textInput}
              onChange={(e) => {
                setTypedValue(e.target.value);
                setHighlightedIndex(-1);
              }}
              onKeyDown={(e) => {
                if (suggestions.length > 0 && e.key === "ArrowDown") {
                  e.preventDefault();
                  setHighlightedIndex((prev) => (prev + 1) % suggestions.length);
                  return;
                }
                if (suggestions.length > 0 && e.key === "ArrowUp") {
                  e.preventDefault();
                  setHighlightedIndex(
                    (prev) => (prev - 1 + suggestions.length) % suggestions.length
                  );
                  return;
                }
                if (e.key === "Enter") {
                  if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
                    const chosen = suggestions[highlightedIndex];
                    setTypedValue(chosen.name);
                    handleGuess(chosen);
                  } else {
                    attemptSubmitTyped();
                  }
                }
              }}
            />
            <button
              type="button"
              style={{
                ...styles.submitButton,
                ...(!!feedback || !getExactMatch(typedValue.trim().toLowerCase())
                  ? styles.submitButtonDisabled
                  : {}),
              }}
              disabled={!!feedback || !getExactMatch(typedValue.trim().toLowerCase())}
              onClick={attemptSubmitTyped}
              aria-label="Submit answer"
            >
              Go
            </button>
          </div>
          {!feedback && suggestions.length > 0 && (
            <div style={styles.suggestionList}>
              {suggestions.map((s, index) => (
                <button
                  key={s.code}
                  style={{
                    ...styles.suggestionItem,
                    ...(index === highlightedIndex
                      ? styles.suggestionItemHighlighted
                      : {}),
                  }}
                  onMouseEnter={() => setHighlightedIndex(index)}
                  onClick={() => {
                    setTypedValue(s.name);
                    handleGuess(s);
                  }}
                >
                  {s.name}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
      <style>{`
        @keyframes lozengePulse {
          0% { transform: scale(1); }
          40% { transform: scale(1.18); }
          100% { transform: scale(1); }
        }
      `}</style>

      {scoreRowStacked ? (
        <>
          <div style={styles.progressDonutWrap}>
            <svg width="56" height="56" viewBox="0 0 64 64">
              <circle cx="32" cy="32" r="27" fill="none" stroke="var(--border-light)" strokeWidth="7" />
              <circle
                cx="32"
                cy="32"
                r="27"
                fill="none"
                stroke="var(--accent)"
                strokeWidth="7"
                strokeLinecap="round"
                strokeDasharray={2 * Math.PI * 27}
                strokeDashoffset={2 * Math.PI * 27 * (1 - attempts / quizSet.length)}
                transform="rotate(-90 32 32)"
                style={{ transition: "stroke-dashoffset 0.3s ease" }}
              />
              <text
                x="32"
                y="37"
                textAnchor="middle"
                fontSize={getDonutCounterFontSize(attempts, quizSet.length)}
                fontWeight="bold"
                fill="var(--text-primary)"
              >
                {attempts}/{quizSet.length}
              </text>
            </svg>
          </div>
          <div style={styles.scoreLozengeRow}>
            <span
              style={{
                ...styles.lozenge,
                backgroundColor: "#28a745",
                animation: correctPulse ? "lozengePulse 0.5s ease-out" : "none",
              }}
            >
              Correct: {score}
            </span>
            <span
              style={{
                ...styles.lozenge,
                backgroundColor: "#e74c3c",
                animation: incorrectPulse ? "lozengePulse 0.5s ease-out" : "none",
              }}
            >
              Incorrect: {attempts - score}
            </span>
          </div>
        </>
      ) : (
        <div ref={scoreRowRef} style={styles.scoreContainer}>
          <span
            style={{
              ...styles.lozenge,
              backgroundColor: "#28a745",
              animation: correctPulse ? "lozengePulse 0.5s ease-out" : "none",
            }}
          >
            Correct: {score}
          </span>
          <svg width="56" height="56" viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="27" fill="none" stroke="var(--border-light)" strokeWidth="7" />
            <circle
              cx="32"
              cy="32"
              r="27"
              fill="none"
              stroke="var(--accent)"
              strokeWidth="7"
              strokeLinecap="round"
              strokeDasharray={2 * Math.PI * 27}
              strokeDashoffset={2 * Math.PI * 27 * (1 - attempts / quizSet.length)}
              transform="rotate(-90 32 32)"
              style={{ transition: "stroke-dashoffset 0.3s ease" }}
            />
            <text
              x="32"
              y="37"
              textAnchor="middle"
              fontSize={getDonutCounterFontSize(attempts, quizSet.length)}
              fontWeight="bold"
              fill="var(--text-primary)"
            >
              {attempts}/{quizSet.length}
            </text>
          </svg>
          <span
            style={{
              ...styles.lozenge,
              backgroundColor: "#e74c3c",
              animation: incorrectPulse ? "lozengePulse 0.5s ease-out" : "none",
            }}
          >
            Incorrect: {attempts - score}
          </span>
        </div>
      )}
        </>
      )}
      <button style={styles.startAgainButton} onClick={backToSelectScreen}>
        Start again
      </button>
      {siteFooter}
    </div>
  );
}

const styles = {
  quizContainer: {
    backgroundColor: "var(--card-bg)",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    maxWidth: "600px",
    width: "100%",
    margin: "auto",
    boxSizing: "border-box",
    position: "relative",
  },
  confettiOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: 9999,
  },
  title: {
    fontSize: "2.4em",
    fontWeight: 800,
    marginBottom: "20px",
    letterSpacing: "-0.02em",
    backgroundImage: "linear-gradient(135deg, var(--accent) 0%, var(--accent-gradient-end) 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "var(--accent)",
    cursor: "pointer",
  },
  resultsSubtitle: {
    fontSize: "1.3em",
    fontWeight: 600,
    color: "var(--text-secondary)",
    marginTop: 0,
    marginBottom: "20px",
  },
  resultsPercentageWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "16px",
  },
  timeStatsRow: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    marginTop: "16px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  timeLozenge: {
    padding: "5px 15px",
    borderRadius: "20px",
    fontSize: "0.95em",
    color: "white",
    backgroundColor: "#6c757d",
  },
  resultsSection: {
    marginTop: "28px",
    textAlign: "left",
  },
  resultsSectionTitle: {
    fontSize: "1.05em",
    fontWeight: 700,
    color: "var(--text-primary)",
    marginBottom: "10px",
  },
  questionBreakdownHeaderRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    marginBottom: "10px",
  },
  filterPillRow: {
    display: "flex",
    gap: "6px",
  },
  filterPill: {
    padding: "4px 10px",
    fontSize: "0.78em",
    color: "var(--text-tertiary)",
    backgroundColor: "var(--chip-bg)",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
  },
  filterPillActive: {
    backgroundColor: "var(--accent)",
    color: "white",
  },
  countryListHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 4px",
    marginBottom: "6px",
    fontSize: "0.8em",
    color: "var(--text-faint)",
  },
  countryListSortButton: {
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "var(--text-faint)",
    cursor: "pointer",
  },
  questionListEmpty: {
    fontSize: "0.9em",
    color: "var(--text-faint)",
    textAlign: "center",
    padding: "16px 0",
    margin: 0,
  },
  questionListEmptyContent: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  continentStatsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  continentStatRow: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  continentStatLabelRow: {
    display: "flex",
    justifyContent: "space-between",
    textAlign: "left",
    fontSize: "0.95em",
    color: "var(--text-primary)",
  },
  continentStatName: {
    flex: "1 1 auto",
    minWidth: 0,
    marginRight: "8px",
  },
  continentStatCount: {
    color: "var(--text-muted)",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  continentStatBarTrack: {
    width: "100%",
    height: "8px",
    backgroundColor: "var(--border-light)",
    borderRadius: "4px",
    overflow: "hidden",
  },
  continentStatBarFill: {
    height: "100%",
    borderRadius: "4px",
    transition: "width 0.4s ease",
  },
  questionList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    maxHeight: "340px",
    overflowY: "auto",
    border: "1px solid var(--border-light)",
    borderRadius: "8px",
    padding: "8px",
    boxSizing: "border-box",
  },
  questionRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "8px 10px",
    borderRadius: "6px",
  },
  questionRowNumber: {
    fontSize: "0.8em",
    color: "var(--text-faint)",
    width: "20px",
    flexShrink: 0,
  },
  questionRowEmoji: {
    fontSize: "1.3em",
    flexShrink: 0,
  },
  questionRowName: {
    flex: 1,
    fontSize: "0.92em",
    color: "var(--text-primary)",
    display: "flex",
    flexDirection: "column",
  },
  questionRowUserAnswer: {
    fontSize: "0.85em",
    color: "var(--text-faint)",
  },
  questionRowIcon: {
    fontSize: "1.1em",
    fontWeight: "bold",
    flexShrink: 0,
  },
  questionRowMode: {
    fontSize: "0.85em",
    flexShrink: 0,
    opacity: 0.7,
  },
  questionRowTime: {
    fontSize: "0.78em",
    color: "var(--text-faint)",
    flexShrink: 0,
    minWidth: "32px",
    textAlign: "right",
  },
  flagContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
  },
  flagBox: {
    position: "relative",
    width: "100%",
    maxWidth: "320px",
    height: "213px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  flagOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "16px",
    boxSizing: "border-box",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    color: "white",
    fontSize: "1.15em",
    fontWeight: "bold",
    textShadow: "0px 1px 3px rgba(0,0,0,0.4)",
  },
  flagOverlayCorrect: {
    backgroundColor: "rgba(40, 167, 69, 0.55)",
  },
  flagOverlayWrong: {
    backgroundColor: "rgba(231, 76, 60, 0.55)",
  },
  overlayLines: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "6px",
  },
  overlaySecondLine: {
    fontWeight: "normal",
    fontSize: "0.85em",
  },
  flagImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    width: "auto",
    height: "auto",
    display: "block",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
  },
  flagFallback: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    backgroundColor: "var(--border-light)",
    color: "var(--text-muted)",
    borderRadius: "4px",
    padding: "16px",
    boxSizing: "border-box",
  },
  flagFallbackNotice: {
    fontSize: "0.85em",
    color: "var(--text-muted)",
  },
  flagEmoji: {
    fontSize: "5em",
    lineHeight: 1,
  },
  selectPrompt: {
    fontSize: "1.1em",
    color: "var(--text-secondary)",
    marginBottom: "20px",
  },
  countOptions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  sliderValueDisplay: {
    fontSize: "1.6em",
    fontWeight: 700,
    color: "var(--accent)",
    marginBottom: "16px",
  },
  sliderWrap: {
    width: "100%",
    maxWidth: "320px",
    margin: "0 auto 24px",
    position: "relative",
  },
  sliderTicks: {
    position: "relative",
    height: "8px",
    marginTop: "4px",
  },
  sliderTick: {
    position: "absolute",
    top: 0,
    width: "1px",
    height: "6px",
    backgroundColor: "var(--border-strong)",
    transform: "translateX(-50%)",
  },
  sliderLabels: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.8em",
    color: "var(--text-faint)",
    marginTop: "4px",
  },
  countButton: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "0 auto",
    padding: "12px 20px",
    fontSize: "1.1em",
    color: "white",
    backgroundColor: "var(--accent)",
    border: "1px solid var(--accent)",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  countButtonNote: {
    display: "block",
    fontSize: "0.68em",
    fontWeight: "normal",
    opacity: 0.85,
    marginTop: "2px",
  },
  nextButtonLabel: {
    display: "block",
  },
  countButtonDisabled: {
    backgroundColor: "var(--disabled-bg)",
    border: "1px solid #aac6e8",
    cursor: "not-allowed",
  },
  continentToggleRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginBottom: "16px",
  },
  toggleChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "6px 14px",
    fontSize: "0.85em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
  },
  toggleChipIcon: {
    fontSize: "0.9em",
  },
  toggleChipDisabled: {
    color: "var(--text-faint)",
    cursor: "not-allowed",
  },
  worldMapWrap: {
    marginBottom: "16px",
  },
  worldMapSvg: {
    display: "block",
    maxWidth: "560px",
    margin: "0 auto",
  },
  continentLegend: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
    maxWidth: "360px",
    margin: "0 auto 16px",
  },
  continentLegendItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    fontSize: "0.85em",
    color: "var(--text-tertiary)",
    backgroundColor: "var(--chip-bg)",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
  },
  continentLegendItemActive: {
    color: "var(--accent-strong)",
    backgroundColor: "var(--link-tint-strong)",
  },
  continentLegendDot: {
    width: "9px",
    height: "9px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  continentCount: {
    color: "var(--text-faint)",
    fontSize: "0.85em",
  },
  continentWarning: {
    color: "#e74c3c",
    fontSize: "0.9em",
    marginBottom: "16px",
  },
  continentActionRow: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },
  backButton: {
    padding: "12px 20px",
    fontSize: "1.1em",
    color: "var(--text-secondary)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid #ccc",
    borderRadius: "5px",
    cursor: "pointer",
  },
  backButtonSpaced: {
    display: "block",
    margin: "16px auto 0",
    width: "100%",
    maxWidth: "300px",
    padding: "12px 20px",
    fontSize: "1.1em",
    color: "var(--text-secondary)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid #ccc",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  quickStartButton: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "16px auto 0",
    padding: "12px 14px",
    fontSize: "1.1em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--link-tint)",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  options: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
  },
  gameTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  modeToggle: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },
  pauseButton: {
    display: "grid",
    placeItems: "center",
    padding: "6px 16px",
    fontSize: "0.85em",
    color: "var(--text-tertiary)",
    backgroundColor: "var(--chip-bg)",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
    flexShrink: 0,
  },
  pauseButtonContent: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    whiteSpace: "nowrap",
  },
  pausedBox: {
    padding: "32px 0 0",
    marginBottom: "0",
  },
  pausedIcon: {
    display: "flex",
    justifyContent: "center",
    color: "var(--text-muted)",
    marginBottom: "8px",
  },
  pausedTitle: {
    fontSize: "1.3em",
    fontWeight: 700,
    color: "var(--text-primary)",
    marginBottom: "8px",
  },
  pausedNote: {
    fontSize: "0.9em",
    color: "var(--text-muted)",
    maxWidth: "280px",
    margin: "0 auto 20px",
    lineHeight: 1.4,
  },
  modeButton: {
    padding: "8px 16px",
    fontSize: "0.9em",
    border: "1px solid #ccc",
    backgroundColor: "var(--card-bg)",
    color: "var(--text-secondary)",
    borderRadius: "20px",
    cursor: "pointer",
    outline: "none",
  },
  modeButtonActive: {
    backgroundColor: "var(--text-secondary)",
    color: "white",
  },
  hardModeBadge: {
    display: "inline-block",
    marginLeft: "6px",
    padding: "1px 7px",
    fontSize: "0.65em",
    fontWeight: 700,
    color: "white",
    backgroundColor: "#e74c3c",
    borderRadius: "10px",
    verticalAlign: "middle",
  },
  achievementBadgeWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "12px",
  },
  achievementBadge: {
    display: "inline-block",
    padding: "4px 12px",
    fontSize: "0.85em",
    fontWeight: 700,
    color: "white",
    borderRadius: "14px",
  },
  modeScreenToggle: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "16px",
    flexWrap: "wrap",
  },
  modeScreenChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "10px 18px",
    fontSize: "0.95em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
  },
  modeScreenChipActive: {
    backgroundColor: "var(--accent)",
    color: "white",
  },
  modeScreenChipDisabled: {
    color: "var(--text-faint)",
    cursor: "not-allowed",
  },
  levelDot: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    boxShadow: "0 0 0 1.5px var(--card-bg)",
    flexShrink: 0,
  },
  modeScreenDescription: {
    fontSize: "0.9em",
    color: "var(--text-tertiary)",
    maxWidth: "300px",
    margin: "0 auto",
    lineHeight: 1.4,
  },
  modeScreenNote: {
    fontSize: "0.85em",
    color: "var(--text-faint)",
    marginTop: "12px",
    marginBottom: "24px",
  },
  textModeContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    marginBottom: "20px",
    position: "relative",
  },
  textInputRow: {
    display: "flex",
    width: "100%",
    maxWidth: "300px",
  },
  textInput: {
    flex: 1,
    minWidth: 0,
    padding: "10px 14px",
    fontSize: "1.1em",
    border: "1px solid #ccc",
    borderRight: "none",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    boxSizing: "border-box",
  },
  submitButton: {
    padding: "10px 18px",
    fontSize: "1.1em",
    color: "white",
    backgroundColor: "var(--accent)",
    border: "none",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
    cursor: "pointer",
  },
  submitButtonDisabled: {
    backgroundColor: "var(--disabled-bg)",
    cursor: "not-allowed",
  },
  suggestionList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "300px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    overflow: "hidden",
  },
  suggestionItem: {
    padding: "10px 14px",
    fontSize: "1em",
    textAlign: "left",
    backgroundColor: "var(--card-bg)",
    color: "var(--text-primary)",
    border: "none",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
  },
  suggestionItemHighlighted: {
    backgroundColor: "var(--link-tint-stronger)",
  },
  suggestionAlias: {
    fontWeight: "bold",
    color: "var(--accent)",
  },
  suggestionArrow: {
    color: "var(--text-faint)",
  },
  optionButton: {
    backgroundColor: "var(--text-secondary)",
    color: "white",
    border: "none",
    padding: "10px 10px",
    fontSize: "1.1em",
    transition: "background-color 0.3s",
    width: "100%",
    maxWidth: "300px",
    height: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    boxSizing: "border-box",
  },
  feedback: {
    fontSize: "1.2em",
    color: "var(--text-primary)",
    marginBottom: "10px",
  },
  scoreContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  progressDonutWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "8px",
  },
  scoreLozengeRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  lozenge: {
    padding: "5px 15px",
    borderRadius: "20px",
    fontSize: "1.1em",
    color: "white",
  },
  playAgain: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "24px auto 0",
    padding: "12px 20px",
    fontSize: "1.1em",
    color: "white",
    backgroundColor: "var(--accent)",
    border: "1px solid var(--accent)",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  shareButton: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "16px auto 0",
    padding: "12px 20px",
    fontSize: "1.1em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--link-tint)",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  startAgainButton: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "16px auto 0",
    padding: "12px 20px",
    fontSize: "1.1em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--link-tint)",
    borderRadius: "5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  attribution: {
    marginTop: "20px",
    fontSize: "0.8em",
    color: "var(--text-faint)",
  },
  attributionLink: {
    color: "var(--text-faint)",
    textDecoration: "underline",
  },
  footerLinkButton: {
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "var(--text-faint)",
    textDecoration: "underline",
    cursor: "pointer",
  },
  changelogIntro: {
    fontSize: "0.9em",
    color: "var(--text-tertiary)",
    marginBottom: "20px",
    lineHeight: 1.4,
  },
  celebrationPreviewList: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px",
  },
  celebrationTierButton: {
    display: "block",
    width: "100%",
    maxWidth: "300px",
    margin: "16px auto 0",
    padding: "12px 20px",
    fontSize: "1.1em",
    fontWeight: 600,
    color: "var(--accent)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--link-tint)",
    borderRadius: "5px",
    cursor: "pointer",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "20px",
  },
  statCard: {
    backgroundColor: "var(--chip-bg)",
    borderRadius: "10px",
    padding: "16px 12px",
    textAlign: "center",
  },
  statValue: {
    fontSize: "1.8em",
    fontWeight: 800,
    color: "var(--accent)",
  },
  statLabel: {
    fontSize: "0.8em",
    color: "var(--text-tertiary)",
    marginTop: "4px",
  },
  statsSectionTitle: {
    fontSize: "1em",
    fontWeight: 700,
    color: "var(--text-primary)",
    textAlign: "left",
    marginBottom: "10px",
  },
  levelSplitList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
  },
  levelBreakdownCard: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 12px",
    backgroundColor: "var(--chip-bg)",
    borderRadius: "8px",
    textAlign: "left",
  },
  levelBreakdownGaugeWrap: {
    flexShrink: 0,
  },
  levelBreakdownTextWrap: {
    flex: 1,
    minWidth: 0,
  },
  levelBreakdownHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
  },
  levelBreakdownTitle: {
    color: "var(--text-secondary)",
    fontWeight: 700,
  },
  levelBreakdownServed: {
    color: "var(--text-tertiary)",
    fontSize: "0.85em",
    marginBottom: "6px",
  },
  levelBreakdownResultsWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px 20px",
  },
  levelBreakdownResultRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "var(--text-secondary)",
    fontSize: "0.9em",
    marginTop: "2px",
    flex: "1 1 140px",
  },
  changelogList: {
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginBottom: "20px",
  },
  changelogEntry: {
    borderBottom: "1px solid #eee",
    paddingBottom: "16px",
  },
  changelogEntryHeader: {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  changelogVersion: {
    fontSize: "0.85em",
    fontWeight: 700,
    color: "white",
    backgroundColor: "var(--accent)",
    padding: "2px 9px",
    borderRadius: "10px",
  },
  changelogTitle: {
    fontSize: "1em",
    fontWeight: 700,
    color: "var(--text-primary)",
  },
  changelogItemList: {
    margin: 0,
    paddingLeft: "20px",
  },
  changelogItem: {
    fontSize: "0.9em",
    color: "var(--text-secondary)",
    marginBottom: "4px",
    lineHeight: 1.4,
  },
  themeToggle: {
    position: "absolute",
    top: "16px",
    left: "16px",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--text-tertiary)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--border-medium)",
    borderRadius: "50%",
    cursor: "pointer",
  },
  changelogCloseButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2em",
    color: "var(--text-tertiary)",
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--border-medium)",
    borderRadius: "50%",
    cursor: "pointer",
  },
};
